// ========================================
// MOCK DATA - FileSave Dashboard
// ========================================
// Simulação de dados da API para desenvolvimento
// Estruturado para simular respostas reais de API REST

import { PLAN_TYPES } from '@/constants';

// ========================================
// LOGIN MOCK
// ========================================
export const mockLoginResponse = {
    status: "success",
    data: {
        token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyIwIjoicGhpbGlwaW5obyIsImV4cCI6MTc1NzM3NjMyNX0.11YxvRboymMG9anhhzeWwgikMJiz0SZLn6WAED-baHU",
        name: "System Web",
        email: "philipinho93@gmail.com",
        image_url: "https://swsystemweb.s3.us-east-1.amazonaws.com/profile/philipinho.jpg",
        settings: {
            slug_page_web: "systemweb"
        }
    }
};

// ========================================
// ARQUIVOS MOCK - DADOS PARA CONTABILIDADE
// ========================================
export const mockFiles = [
    {
        id: 1,
        name: 'Notas Fiscais Entrada Nov/24 - Restaurante Sabor Caseiro',
        type: 'Notas Fiscais de Entrada',
        category: 'Documentos Fiscais - Restaurantes',
        group: 'trabalho',
        status: 'active',
        personType: 'juridica',
        createdAt: '2024-12-01T10:30:00Z',
        expiryDate: '2024-12-10T23:59:59Z',
        fileSize: '15.2 MB',
        fileFormat: 'PDF',
        documentNumber: 'NFE-NOV-2024',
        userId: 1,
        company: {
            id: 2,
            name: 'Restaurante Sabor Caseiro Ltda',
            image: 'https://www.fivebranches.edu/wp-content/uploads/2021/08/default-image.jpg'
        },
        metadata: {
            uploadedBy: 'João Silva - Restaurante Sabor Caseiro',
            lastModified: '2024-12-01T10:30:00Z',
            tags: ['notas-fiscais', 'entrada', 'novembro', 'fechamento'],
            isPublic: false,
            hasNotifications: true
        }
    },
    {
        id: 2,
        name: 'Extratos Bancários Nov/24 - Loja Mania Fashion',
        type: 'Extratos Bancários',
        category: 'Documentos Bancários - Varejo',
        group: 'financeiro',
        status: 'expiring',
        personType: 'juridica',
        createdAt: '2024-11-28T14:15:00Z',
        expiryDate: '2024-12-10T23:59:59Z',
        fileSize: '3.4 MB',
        fileFormat: 'PDF',
        documentNumber: 'EXT-BB-NOV-2024',
        userId: 2,
        company: {
            id: 3,
            name: 'TechCorp Soluções Digitais',
            image: 'https://www.fivebranches.edu/wp-content/uploads/2021/08/default-image.jpg'
        },
        metadata: {
            uploadedBy: 'Maria Santos - Loja Mania Fashion',
            lastModified: '2024-11-28T14:15:00Z',
            tags: ['extrato', 'bancário', 'novembro', 'fechamento'],
            isPublic: false,
            hasNotifications: true
        }
    },
    {
        id: 3,
        name: 'Livro Diário 2024 - Distribuidora Central',
        type: 'Livro Diário',
        category: 'Escrituração Contábil - Distribuidoras',
        group: 'trabalho',
        status: 'active',
        personType: 'juridica',
        createdAt: '2024-11-25T09:45:00Z',
        expiryDate: null,
        fileSize: '28.7 MB',
        fileFormat: 'PDF',
        documentNumber: 'LD-2024-DISTRIBUIDORA',
        userId: 3,
        company: {
            id: 5,
            name: 'Consultoria Empresarial JR',
            image: 'https://www.fivebranches.edu/wp-content/uploads/2021/08/default-image.jpg'
        },
        metadata: {
            uploadedBy: 'Carlos Oliveira - Distribuidora Central',
            lastModified: '2024-11-25T09:45:00Z',
            tags: ['livro-diário', 'escrituração', 'auditoria'],
            isPublic: false,
            hasNotifications: false
        }
    },
    {
        id: 4,
        name: 'Folha de Pagamento Dez/24 - Transportadora Rápida',
        type: 'Folha de Pagamento',
        category: 'Recursos Humanos - Transportadoras',
        group: 'trabalho',
        status: 'expiring',
        personType: 'juridica',
        createdAt: '2024-11-20T16:20:00Z',
        expiryDate: '2025-01-20T23:59:59Z',
        fileSize: '6.8 MB',
        fileFormat: 'PDF',
        documentNumber: 'FP-DEZ-2024-TRANSPORTADORA',
        userId: 1,
        metadata: {
            uploadedBy: 'Paulo Santos - Transportadora Rápida',
            lastModified: '2024-11-20T16:20:00Z',
            tags: ['folha-pagamento', 'dezembro', 'encargos'],
            isPublic: false,
            hasNotifications: true
        }
    },
    {
        id: 5,
        name: 'DARFs Vencimento 31/03 - IRPJ Oficina dos Irmãos',
        type: 'DARF',
        category: 'Impostos e Tributos - Oficinas',
        group: 'financeiro',
        status: 'expiring',
        personType: 'juridica',
        createdAt: '2024-11-10T14:30:00Z',
        expiryDate: '2025-03-31T23:59:59Z',
        fileSize: '2.1 MB',
        fileFormat: 'PDF',
        documentNumber: 'DARF-IRPJ-2024-OFICINA',
        userId: 1,
        metadata: {
            uploadedBy: 'Roberto Silva - Oficina dos Irmãos',
            lastModified: '2024-11-10T14:30:00Z',
            tags: ['darf', 'irpj', 'imposto-renda'],
            isPublic: false,
            hasNotifications: true
        }
    },
    {
        id: 6,
        name: 'ECF 2024 Transmitida - Oficina Mecânica dos Irmãos',
        type: 'ECF',
        category: 'Escrituração Digital - SPED',
        group: 'trabalho',
        status: 'active',
        personType: 'juridica',
        createdAt: '2024-11-15T11:10:00Z',
        expiryDate: null,
        fileSize: '5.7 MB',
        fileFormat: 'XML',
        documentNumber: 'ECF-2024-OFICINA-IRMAOS',
        userId: 4,
        metadata: {
            uploadedBy: 'Roberto Silva - Oficina dos Irmãos',
            lastModified: '2024-11-15T11:10:00Z',
            tags: ['ecf', 'escrituração', 'sped'],
            isPublic: false,
            hasNotifications: false
        }
    },
    {
        id: 7,
        name: 'Contrato Social Alterado - Padaria Pão Dourado',
        type: 'Contrato Social',
        category: 'Documentos Societários - Padarias',
        group: 'trabalho',
        status: 'active',
        personType: 'juridica',
        createdAt: '2024-11-10T13:30:00Z',
        expiryDate: null,
        fileSize: '4.8 MB',
        fileFormat: 'PDF',
        documentNumber: 'CS-ALT-2024-PADARIA',
        userId: 2,
        metadata: {
            uploadedBy: 'Ana Santos - Padaria Pão Dourado',
            lastModified: '2024-11-10T13:30:00Z',
            tags: ['contrato-social', 'alteração', 'junta-comercial'],
            isPublic: false,
            hasNotifications: true
        }
    },
    {
        id: 8,
        name: 'GPS INSS Dezembro/24 - Transportadora Rápida',
        type: 'GPS',
        category: 'Guias de Recolhimento - INSS/FGTS',
        group: 'trabalho',
        status: 'expiring',
        personType: 'juridica',
        createdAt: '2024-11-05T08:45:00Z',
        expiryDate: '2025-01-20T23:59:59Z',
        fileSize: '1.2 MB',
        fileFormat: 'PDF',
        documentNumber: 'GPS-DEZ-2024-TRANSPORTADORA',
        userId: 3,
        metadata: {
            uploadedBy: 'Paulo Santos - Transportadora Rápida',
            lastModified: '2024-11-05T08:45:00Z',
            tags: ['gps', 'inss', 'folha-pagamento'],
            isPublic: false,
            hasNotifications: true
        }
    },
    {
        id: 9,
        name: 'Balanço Patrimonial 2024 - Distribuidora Central',
        type: 'Balanço Patrimonial',
        category: 'Demonstrações Financeiras - Auditoria',
        group: 'trabalho',
        status: 'active',
        personType: 'juridica',
        createdAt: '2024-10-30T15:25:00Z',
        expiryDate: null,
        fileSize: '8.4 MB',
        fileFormat: 'PDF',
        documentNumber: 'BP-2024-DISTRIBUIDORA',
        userId: 3,
        metadata: {
            uploadedBy: 'Carlos Oliveira - Distribuidora Central',
            lastModified: '2024-10-30T15:25:00Z',
            tags: ['balanço', 'patrimonial', 'auditoria'],
            isPublic: false,
            hasNotifications: false
        }
    },
    {
        id: 10,
        name: 'RG - Pedro Almeida Santos',
        type: 'RG',
        category: 'Arquivos de Identidade',
        group: 'pessoal',
        status: 'active',
        personType: 'fisica',
        createdAt: '2024-10-25T12:15:00Z',
        expiryDate: '2034-10-25T23:59:59Z',
        fileSize: '1.5 MB',
        fileFormat: 'JPG',
        documentNumber: '12.345.678-9',
        userId: 5,
        metadata: {
            uploadedBy: 'Pedro Almeida Santos',
            lastModified: '2024-10-25T12:15:00Z',
            tags: ['rg', 'identidade', 'arquivo'],
            isPublic: false,
            hasNotifications: false
        }
    },
    {
        id: 11,
        name: 'Passaporte - Ana Costa Silva',
        type: 'Passaporte',
        category: 'Arquivos de Viagem',
        group: 'pessoal',
        status: 'active',
        personType: 'fisica',
        createdAt: '2024-10-20T09:30:00Z',
        expiryDate: '2029-10-20T23:59:59Z',
        fileSize: '2.8 MB',
        fileFormat: 'PDF',
        documentNumber: 'BR1234567',
        userId: 4,
        metadata: {
            uploadedBy: 'Ana Costa Silva',
            lastModified: '2024-10-20T09:30:00Z',
            tags: ['passaporte', 'viagem', 'internacional'],
            isPublic: false,
            hasNotifications: true
        }
    },
    {
        id: 12,
        name: 'RG - João Silva Santos',
        type: 'RG',
        category: 'Arquivos de Identidade',
        group: 'pessoal',
        status: 'active',
        personType: 'fisica',
        createdAt: '2024-10-25T12:15:00Z',
        expiryDate: '2034-10-25T23:59:59Z',
        fileSize: '1.5 MB',
        fileFormat: 'JPG',
        documentNumber: '12.345.678-9',
        userId: 1,
        metadata: {
            uploadedBy: 'João Silva Santos',
            lastModified: '2024-10-25T12:15:00Z',
            tags: ['rg', 'identidade', 'arquivo'],
            isPublic: false,
            hasNotifications: false
        }
    },
    {
        id: 13,
        name: 'CRLV - Veículo Fiat Toro',
        type: 'CRLV',
        category: 'Veículos',
        group: 'pessoal',
        status: 'active',
        personType: 'fisica',
        createdAt: '2024-11-20T16:20:00Z',
        expiryDate: '2026-09-25T23:59:59Z',
        fileSize: '1.3 MB',
        fileFormat: 'PDF',
        documentNumber: 'CRLV-DEF5678',
        userId: 1,
        metadata: {
            uploadedBy: 'João Silva Santos',
            lastModified: '2024-11-20T16:20:00Z',
            tags: ['veículo', 'crlv', 'licenciamento'],
            isPublic: false,
            hasNotifications: true
        }
    },
    {
        id: 14,
        name: 'Seguro do Veículo - Fiat Toro',
        type: 'Seguro Veicular',
        category: 'Veículos',
        group: 'pessoal',
        status: 'active',
        personType: 'fisica',
        createdAt: '2024-11-10T14:30:00Z',
        expiryDate: '2025-11-20T23:59:59Z',
        fileSize: '1.8 MB',
        fileFormat: 'PDF',
        documentNumber: 'SEG-2024-002',
        userId: 1,
        metadata: {
            uploadedBy: 'João Silva Santos',
            lastModified: '2024-11-10T14:30:00Z',
            tags: ['seguro', 'veículo', 'proteção'],
            isPublic: false,
            hasNotifications: true
        }
    },
    {
        id: 15,
        name: 'CNH - Carteira Nacional de Habilitação',
        type: 'CNH',
        category: 'Documentos Pessoais',
        group: 'pessoal',
        status: 'expiring',
        personType: 'fisica',
        createdAt: '2024-10-15T10:00:00Z',
        expiryDate: '2024-12-15T23:59:59Z',
        fileSize: '850 KB',
        fileFormat: 'PDF',
        documentNumber: 'CNH-12345678900',
        userId: 1,
        company: {
            id: 1,
            name: 'Pessoal',
            image: null
        },
        metadata: {
            uploadedBy: 'João Silva Santos',
            lastModified: '2024-10-15T10:00:00Z',
            tags: ['cnh', 'habilitação', 'documento-pessoal'],
            isPublic: false,
            hasNotifications: true
        }
    },
    {
        id: 16,
        name: 'Alvará de Funcionamento - Pizzaria Bella Itália',
        type: 'Alvará de Funcionamento',
        category: 'Documentos Legais - Restaurantes',
        group: 'trabalho',
        status: 'expiring',
        personType: 'juridica',
        createdAt: '2024-09-20T11:30:00Z',
        expiryDate: '2024-12-20T23:59:59Z',
        fileSize: '2.3 MB',
        fileFormat: 'PDF',
        documentNumber: 'ALV-2024-PIZZARIA',
        userId: 2,
        company: {
            id: 2,
            name: 'Restaurante Sabor Caseiro Ltda',
            image: 'https://www.fivebranches.edu/wp-content/uploads/2021/08/default-image.jpg'
        },
        metadata: {
            uploadedBy: 'Maria Santos - Pizzaria Bella Itália',
            lastModified: '2024-09-20T11:30:00Z',
            tags: ['alvará', 'funcionamento', 'estabelecimento'],
            isPublic: false,
            hasNotifications: true
        }
    },
    {
        id: 17,
        name: 'RG - Registro Geral',
        type: 'RG',
        category: 'Documentos Pessoais',
        group: 'pessoal',
        status: 'expired',
        personType: 'fisica',
        createdAt: '2024-06-10T09:00:00Z',
        expiryDate: '2024-10-10T23:59:59Z',
        fileSize: '650 KB',
        fileFormat: 'PDF',
        documentNumber: 'RG-98765432100',
        userId: 1,
        company: {
            id: 1,
            name: 'Pessoal',
            image: null
        },
        metadata: {
            uploadedBy: 'João Silva Santos',
            lastModified: '2024-06-10T09:00:00Z',
            tags: ['rg', 'documento-pessoal', 'identidade'],
            isPublic: false,
            hasNotifications: true
        }
    },
    {
        id: 18,
        name: 'Certidão de Regularidade Fiscal - Comércio XYZ',
        type: 'Certidão de Regularidade Fiscal',
        category: 'Documentos Fiscais - Comércio',
        group: 'trabalho',
        status: 'expired',
        personType: 'juridica',
        createdAt: '2024-05-01T14:00:00Z',
        expiryDate: '2024-09-01T23:59:59Z',
        fileSize: '1.2 MB',
        fileFormat: 'PDF',
        documentNumber: 'CRF-2024-XYZ',
        userId: 2,
        company: {
            id: 3,
            name: 'TechCorp Soluções Digitais',
            image: 'https://www.fivebranches.edu/wp-content/uploads/2021/08/default-image.jpg'
        },
        metadata: {
            uploadedBy: 'Carlos Souza - Comércio XYZ',
            lastModified: '2024-05-01T14:00:00Z',
            tags: ['certidão', 'fiscal', 'regularidade'],
            isPublic: false,
            hasNotifications: true
        }
    }
];

// ========================================
// USUÁRIOS MOCK
// ========================================
export const mockUsers = [
    {
        id: 1,
        name: 'João Silva Santos',
        email: 'joao.santos@email.com',
        avatar: null,
        role: 'user',
        plan: PLAN_TYPES.ENTERPRISE,
        createdAt: '2024-01-15T10:00:00Z',
        lastLogin: '2024-12-01T10:30:00Z',
        isActive: true,
        settings: {
            notifications: true,
            theme: 'light',
            language: 'pt-BR'
        }
    },
    {
        id: 2,
        name: 'Maria Santos Oliveira',
        email: 'maria.oliveira@email.com',
        avatar: null,
        role: 'user',
        plan: PLAN_TYPES.PERSONAL,
        createdAt: '2024-02-10T14:30:00Z',
        lastLogin: '2024-11-28T14:15:00Z',
        isActive: true,
        settings: {
            notifications: true,
            theme: 'light',
            language: 'pt-BR'
        }
    },
    {
        id: 3,
        name: 'Carlos Oliveira Lima',
        email: 'carlos.lima@empresatech.com',
        avatar: null,
        role: 'admin',
        plan: PLAN_TYPES.ENTERPRISE,
        createdAt: '2024-03-05T08:00:00Z',
        lastLogin: '2024-11-25T09:45:00Z',
        isActive: true,
        settings: {
            notifications: true,
            theme: 'dark',
            language: 'pt-BR'
        }
    },
    {
        id: 4,
        name: 'Ana Costa Silva',
        email: 'ana.silva@email.com',
        avatar: null,
        role: 'user',
        plan: PLAN_TYPES.PERSONAL,
        createdAt: '2024-04-12T16:20:00Z',
        lastLogin: '2024-11-15T11:10:00Z',
        isActive: true,
        settings: {
            notifications: false,
            theme: 'light',
            language: 'pt-BR'
        }
    },
    {
        id: 5,
        name: 'Pedro Almeida Santos',
        email: 'pedro.almeida@email.com',
        avatar: null,
        role: 'user',
        plan: PLAN_TYPES.PROFESSIONAL,
        createdAt: '2024-05-20T13:45:00Z',
        lastLogin: '2024-10-25T12:15:00Z',
        isActive: true,
        settings: {
            notifications: true,
            theme: 'light',
            language: 'pt-BR'
        }
    }
];

// ========================================
// CATEGORIAS DE DOCUMENTOS
// ========================================
export const fileCategories = [
    {
        id: 1,
        name: 'Arquivos de Identidade',
        slug: 'identidade',
        description: 'RG, CPF, CNH, Título de Eleitor',
        icon: 'user',
        color: '#3b82f6'
    },
    {
        id: 2,
        name: 'Arquivos de Viagem',
        slug: 'viagem',
        description: 'Passaporte, Visto',
        icon: 'file-text',
        color: '#10b981'
    },
    {
        id: 3,
        name: 'Arquivos de Saúde',
        slug: 'saude',
        description: 'Cartão SUS, Exames, Carteira de Vacinação',
        icon: 'file-text',
        color: '#f59e0b'
    },
    {
        id: 4,
        name: 'Comprovantes',
        slug: 'comprovantes',
        description: 'Residência, Escolaridade, Renda',
        icon: 'home',
        color: '#8b5cf6'
    },
    {
        id: 5,
        name: 'Financeiros/Contratuais',
        slug: 'financeiros',
        description: 'Contratos, Notas Fiscais, Extratos',
        icon: 'file-text',
        color: '#ef4444'
    },
    {
        id: 6,
        name: 'Veículos',
        slug: 'veiculos',
        description: 'CRLV, Seguro Veicular',
        icon: 'credit-card',
        color: '#06b6d4'
    },
    {
        id: 7,
        name: 'Arquivos Empresariais',
        slug: 'empresariais',
        description: 'CNPJ, Contratos Sociais, Alterações',
        icon: 'office',
        color: '#84cc16'
    },
    {
        id: 8,
        name: 'Licenças e Autorizações',
        slug: 'licencas',
        description: 'Alvarás, Certificados, AVCB',
        icon: 'file-text',
        color: '#f97316'
    }
];

// ========================================
// ESTATÍSTICAS DO DASHBOARD
// ========================================
export const dashboardStats = {
    totalDocuments: 11,
    activeDocuments: 7,
    expiringDocuments: 3,
    expiredDocuments: 1,
    storageUsed: '18.4 MB',
    storageLimit: '100 MB',
    storagePercentage: 18.4,
    recentUploads: 4,
    notifications: 5
};

// ========================================
// ATIVIDADES RECENTES DO SISTEMA
// ========================================
export const recentActivitiesData = [
    {
        id: 1,
        type: 'upload',
        action: 'UPLOAD',
        description: 'Notas Fiscais Nov/24 - Restaurante Sabor Caseiro foram enviadas (127 arquivos)',
        timestamp: new Date(Date.now() - 2 * 60 * 1000)
    },
    {
        id: 2,
        type: 'download',
        action: 'DOWNLOAD',
        description: 'IRPJ 2024 - Oficina dos Irmãos foi baixado',
        timestamp: new Date(Date.now() - 8 * 60 * 1000)
    },
    {
        id: 3,
        type: 'share',
        action: 'COMPARTILHAMENTO',
        description: 'Folha Dezembro/24 - Transportadora Rápida foi compartilhada',
        timestamp: new Date(Date.now() - 15 * 60 * 1000)
    },
    {
        id: 4,
        type: 'alert',
        action: 'ALERTA PRAZO',
        description: 'GPS INSS Dezembro/24 vence em 15 dias - atenção aos prazos!',
        timestamp: new Date(Date.now() - 25 * 60 * 1000)
    },
    {
        id: 5,
        type: 'upload',
        action: 'TRANSMISSÃO',
        description: 'ECF 2024 transmitida com sucesso - Oficina dos Irmãos',
        timestamp: new Date(Date.now() - 45 * 60 * 1000)
    },
    {
        id: 6,
        type: 'urgent',
        action: 'AUDITORIA URGENTE',
        description: 'Livro Diário 2024 - Distribuidora Central solicitado pela Receita Federal',
        timestamp: new Date(Date.now() - 1 * 60 * 60 * 1000)
    },
    {
        id: 7,
        type: 'approval',
        action: 'APROVAÇÃO',
        description: 'Contrato Social Alterado - Padaria Pão Dourado aprovado pela Junta Comercial',
        timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000)
    },
    {
        id: 8,
        type: 'upload',
        action: 'FECHAMENTO PENDENTE',
        description: 'Nov/24 - Loja Mania Fashion: faltam extratos bancários',
        timestamp: new Date(Date.now() - 3 * 60 * 60 * 1000)
    },
    {
        id: 9,
        type: 'reminder',
        action: 'LEMBRETE IMPOSTO',
        description: 'DARF IRPJ vencimento 31/03 - Oficina dos Irmãos precisa ser quitado',
        timestamp: new Date(Date.now() - 4 * 60 * 60 * 1000)
    },
    {
        id: 10,
        type: 'download',
        action: 'DOWNLOAD',
        description: 'Balanço Patrimonial 2024 - Distribuidora Central foi baixado',
        timestamp: new Date(Date.now() - 6 * 60 * 60 * 1000)
    }
];

// ========================================
// NOTIFICAÇÕES MOCK
// ========================================
export const mockNotifications = [
    {
        id: 1,
        title: 'PRAZO FECHAMENTO: Loja Mania Fashion',
        message: 'Fechamento Nov/24 vence em 3 dias. Faltam: extratos bancários e NF saída.',
        type: 'warning',
        documentId: 2,
        userId: 1,
        isRead: false,
        createdAt: '2024-12-01T08:00:00Z'
    },
    {
        id: 2,
        title: 'Notas Fiscais recebidas',
        message: 'Restaurante Sabor Caseiro enviou NFe Nov/24 completas (127 documentos).',
        type: 'success',
        documentId: 1,
        userId: 1,
        isRead: true,
        createdAt: '2024-12-01T10:31:00Z'
    },
    {
        id: 3,
        title: '🚨 AUDITORIA RECEITA FEDERAL',
        message: 'Distribuidora Central: RF confirmou auditoria. URGENTE: 48h para envio.',
        type: 'error',
        documentId: 3,
        userId: 2,
        isRead: false,
        createdAt: '2024-12-02T00:01:00Z'
    },
    {
        id: 4,
        title: 'Backup realizado',
        message: 'Backup automático de todos os arquivos concluído.',
        type: 'info',
        documentId: null,
        userId: null,
        isRead: true,
        createdAt: '2024-12-02T03:00:00Z'
    },
    {
        id: 5,
        title: 'Novo login detectado',
        message: 'Acesso realizado de um novo dispositivo.',
        type: 'info',
        documentId: null,
        userId: 3,
        isRead: false,
        createdAt: '2024-11-25T09:46:00Z'
    }
];

// ========================================
// DADOS DE ATIVIDADE RECENTE
// ========================================
export const recentActivity = [
    {
        id: 1,
        type: 'upload',
        title: 'Notas Fiscais Nov/24 - Restaurante Sabor Caseiro foram enviadas (127 arquivos)',
        message: 'Notas Fiscais Nov/24 - Restaurante Sabor Caseiro foram enviadas (127 arquivos)',
        userId: 1,
        documentId: 1,
        timestamp: '2024-12-01T10:30:00Z'
    },
    {
        id: 2,
        type: 'download',
        title: 'IRPJ 2024 - Oficina dos Irmãos foi baixado',
        message: 'IRPJ 2024 - Oficina dos Irmãos foi baixado',
        userId: 2,
        documentId: 5,
        timestamp: '2024-11-30T16:20:00Z'
    },
    {
        id: 3,
        type: 'share',
        title: 'Folha Dezembro/24 - Transportadora Rápida foi compartilhada',
        message: 'Folha Dezembro/24 - Transportadora Rápida foi compartilhada',
        userId: 3,
        documentId: 4,
        timestamp: '2024-11-29T14:15:00Z'
    },
    {
        id: 4,
        type: 'expire_warning',
        title: 'GPS INSS Dezembro/24 vence em 15 dias - atenção aos prazos!',
        message: 'GPS INSS Dezembro/24 vence em 15 dias - atenção aos prazos!',
        userId: 1,
        documentId: 8,
        timestamp: '2024-11-28T08:00:00Z'
    },
    {
        id: 5,
        type: 'upload',
        title: 'ECF 2024 transmitida com sucesso - Oficina dos Irmãos',
        message: 'ECF 2024 transmitida com sucesso - Oficina dos Irmãos',
        userId: 2,
        documentId: 6,
        timestamp: '2024-11-27T15:45:00Z'
    },
    {
        id: 6,
        type: 'urgent',
        title: '🚨 AUDITORIA: Livro Diário 2024 - Distribuidora Central solicitado',
        message: '🚨 AUDITORIA: Livro Diário 2024 - Distribuidora Central solicitado',
        userId: 3,
        documentId: 3,
        timestamp: '2024-11-26T09:30:00Z'
    },
    {
        id: 7,
        type: 'approval',
        title: 'Contrato Social Alterado - Padaria Pão Dourado aprovado pela Junta Comercial',
        message: 'Contrato Social Alterado - Padaria Pão Dourado aprovado pela Junta Comercial',
        userId: 2,
        documentId: 7,
        timestamp: '2024-11-25T11:20:00Z'
    },
    {
        id: 8,
        type: 'reminder',
        title: 'Fechamento Nov/24 - Loja Mania Fashion: faltam extratos bancários',
        message: 'Fechamento Nov/24 - Loja Mania Fashion: faltam extratos bancários',
        userId: 1,
        documentId: 2,
        timestamp: '2024-11-24T14:00:00Z'
    }
];

// ========================================
// GRUPOS POR TIPO DE ARQUIVO
// ========================================
export const fileGroups = [
    {
        id: 1,
        name: 'Arquivos PDF',
        type: 'fileType',
        count: 24,
        stats: { expiring: 3, expired: 1 },
        icon: 'file-pdf',
        color: '#ef4444',
        documents: mockFiles.filter(doc => doc.fileFormat === 'PDF')
    },
    {
        id: 2,
        name: 'Imagens',
        type: 'fileType',
        count: 18,
        stats: { expiring: 2, expired: 0 },
        icon: 'image',
        color: '#10b981',
        documents: mockFiles.filter(doc => ['JPG', 'JPEG', 'PNG', 'WEBP'].includes(doc.fileFormat))
    },
    {
        id: 3,
        name: 'Arquivos Word',
        type: 'fileType', 
        count: 12,
        stats: { expiring: 1, expired: 0 },
        icon: 'file-text',
        color: '#3b82f6',
        documents: mockFiles.filter(doc => ['DOC', 'DOCX'].includes(doc.fileFormat))
    },
    {
        id: 4,
        name: 'Planilhas Excel',
        type: 'fileType',
        count: 8,
        stats: { expiring: 0, expired: 1 },
        icon: 'table',
        color: '#f59e0b',
        documents: mockFiles.filter(doc => ['XLS', 'XLSX'].includes(doc.fileFormat))
    },
    {
        id: 5,
        name: 'Apresentações',
        type: 'fileType',
        count: 6,
        stats: { expiring: 1, expired: 0 },
        icon: 'play',
        color: '#8b5cf6',
        documents: mockFiles.filter(doc => ['PPT', 'PPTX'].includes(doc.fileFormat))
    },
    {
        id: 6,
        name: 'Outros Arquivos',
        type: 'fileType',
        count: 4,
        stats: { expiring: 0, expired: 0 },
        icon: 'file-empty',
        color: '#6b7280',
        documents: mockFiles.filter(doc => !['PDF', 'JPG', 'JPEG', 'PNG', 'WEBP', 'DOC', 'DOCX', 'XLS', 'XLSX', 'PPT', 'PPTX'].includes(doc.fileFormat))
    }
];

// ========================================
// COMPARTILHAMENTOS MOCK
// ========================================
export const mockShares = [
    {
        id: 1,
        title: 'IRPJ 2024 - Oficina Mecânica dos Irmãos',
        description: 'Entrega de Declaração IRPJ, ECF transmitida e DARFs para pagamento',
        shareUrl: 'https://filesave.com/share/irpj-oficina-irmaos-2024',
        slugUrl: 'irpj-oficina-irmaos-2024',
        status: 'active',
        createdAt: '2024-12-01T10:30:00Z',
        expiryDate: '2025-03-31T23:59:59Z',
        documentIds: [5, 6],
        stats: {
            views: 15,
            downloads: 8
        },
        settings: {
            allowDownload: true,
            requireAuth: true,
            passwordProtected: true,
            password: '12345678'
        }
    },
    {
        id: 2,
        title: 'Folha Dezembro 2024 - Transportadora Rápida',
        description: 'Folha analtica, GPS, FGTS e comprovantes de transmissão eSocial',
        shareUrl: 'https://filesave.com/share/folha-transportadora-rapida-dez24',
        slugUrl: 'folha-transportadora-rapida-dez24',
        status: 'active',
        createdAt: '2024-11-28T14:15:00Z',
        expiryDate: '2025-03-28T23:59:59Z',
        documentIds: [4, 8],
        stats: {
            views: 28,
            downloads: 12
        },
        settings: {
            allowDownload: true,
            requireAuth: false,
            passwordProtected: true,
            password: 'DEZ2024'
        }
    },
    {
        id: 3,
        title: 'Alteração Contratual - Padaria Pão Dourado',
        description: 'Contrato social alterado, certidão atualizada e protocolos da Junta Comercial',
        shareUrl: 'https://filesave.com/share/alteracao-padaria-pao-dourado',
        slugUrl: 'alteracao-padaria-pao-dourado',
        status: 'active',
        createdAt: '2024-10-15T09:20:00Z',
        expiryDate: '2025-01-15T23:59:59Z',
        documentIds: [7],
        stats: {
            views: 23,
            downloads: 8
        },
        settings: {
            allowDownload: false,
            requireAuth: true,
            passwordProtected: false
        }
    },
    {
        id: 4,
        title: 'Comprovantes de Residência',
        description: 'Arquivos para abertura de conta bancária',
        shareUrl: 'https://filesave.com/share/carlos-oliveira/comprovantes',
        slugUrl: 'carlos-oliveira-comprovantes',
        status: 'inactive',
        createdAt: '2024-11-20T16:45:00Z',
        expiryDate: '2025-01-20T23:59:59Z',
        documentIds: [6],
        stats: {
            views: 7,
            downloads: 2
        },
        settings: {
            allowDownload: true,
            requireAuth: false,
            passwordProtected: true
        }
    },
    {
        id: 5,
        title: 'Arquivos de Viagem',
        description: 'Passaporte e visto para processo de imigração',
        shareUrl: 'https://filesave.com/share/ana-costa/viagem-eua',
        slugUrl: 'ana-costa-viagem-eua',
        status: 'active',
        createdAt: '2024-12-05T11:00:00Z',
        expiryDate: '2025-06-05T23:59:59Z',
        documentIds: [7],
        stats: {
            views: 89,
            downloads: 34
        },
        settings: {
            allowDownload: true,
            requireAuth: true,
            passwordProtected: true
        }
    },
    {
        id: 'share_protected_123',
        title: 'Documentos Empresariais - TechCorp LTDA',
        description: 'Documentos confidenciais da empresa incluindo contratos, certidões e licenças',
        status: 'active',
        accessType: 'protected',
        shareUrl: 'https://filesave.com.br/share/protected/abc123def456',
        slugUrl: 'techcorp-ltda-documentos-empresariais',
        accessEmail: 'admin@techcorp.com.br',
        accessPassword: null, // Senha não é retornada por segurança
        hasExpiry: 'yes',
        expiryDate: '2025-06-15T23:59:59Z',
        createdAt: '2024-12-10T14:30:00Z',
        updatedAt: '2024-12-15T09:15:00Z',
        userId: 1,
        stats: {
            views: 47,
            downloads: 23,
            lastAccess: '2024-12-14T16:45:00Z'
        },
        files: [
            {
                id: 1,
                name: 'CNH - João Silva Santos',
                type: 'CNH',
                size: '2.4 MB'
            },
            {
                id: 12,
                name: 'RG - João Silva Santos',
                type: 'RG',
                size: '1.5 MB'
            },
            {
                id: 13,
                name: 'CRLV - Veículo Fiat Toro',
                type: 'CRLV',
                size: '3.2 MB'
            }
        ],
        security: {
            passwordCreatedAt: '2024-12-10T14:30:00Z',
            passwordLastChanged: null,
            accessAttempts: 3,
            lastSuccessfulLogin: '2024-12-14T16:45:00Z'
        }
    }
];

// ========================================
// DOCUMENTOS POR PÁGINA DE COMPARTILHAMENTO MOCK
// ========================================
export const mockShareDocuments = {
    1: [ // Arquivos Pessoais - João Silva
        {
            id: 1,
            name: 'CNH - João Silva Santos',
            type: 'CNH',
            category: 'Arquivos de Identidade',
            fileSize: '2.4 MB',
            fileFormat: 'PDF',
            expiryDate: '2027-03-15T23:59:59Z',
            status: 'active',
            addedAt: '2024-12-01T10:30:00Z'
        },
        {
            id: 12,
            name: 'RG - João Silva Santos',
            type: 'RG',
            category: 'Arquivos de Identidade',
            fileSize: '1.5 MB',
            fileFormat: 'JPG',
            expiryDate: '2034-10-25T23:59:59Z',
            status: 'active',
            addedAt: '2024-12-01T11:15:00Z'
        },
        {
            id: 13,
            name: 'CRLV - Veículo Fiat Toro',
            type: 'CRLV',
            category: 'Veículos',
            fileSize: '1.3 MB',
            fileFormat: 'PDF',
            expiryDate: '2026-09-25T23:59:59Z',
            status: 'active',
            addedAt: '2024-12-01T14:20:00Z'
        }
    ],
    2: [ // Contratos Empresariais - TechCorp
        {
            id: 3,
            name: 'CNPJ - Empresa Tech Ltda',
            type: 'CNPJ',
            category: 'Arquivos Empresariais',
            fileSize: '890 KB',
            fileFormat: 'PDF',
            expiryDate: null,
            status: 'active',
            addedAt: '2024-11-28T14:15:00Z'
        },
        {
            id: 8,
            name: 'Alvará de Funcionamento - Loja Comercial',
            type: 'Alvará',
            category: 'Licenças e Autorizações',
            fileSize: '1.8 MB',
            fileFormat: 'PDF',
            expiryDate: '2025-11-05T23:59:59Z',
            status: 'active',
            addedAt: '2024-11-28T15:30:00Z'
        },
        {
            id: 7,
            name: 'Contrato de Aluguel - Apartamento Centro',
            type: 'Contrato de Aluguel',
            category: 'Financeiros/Contratuais',
            fileSize: '3.2 MB',
            fileFormat: 'PDF',
            expiryDate: '2024-12-01T23:59:59Z',
            status: 'expired',
            addedAt: '2024-11-28T16:45:00Z'
        }
    ],
    3: [ // Arquivos Vencidos - Alerta (compartilhamento expirado, sem documentos)
    ],
    4: [ // Comprovantes de Residência
        {
            id: 2,
            name: 'Comprovante de Residência - Maria Santos',
            type: 'Comprovante de Residência',
            category: 'Comprovantes',
            fileSize: '1.1 MB',
            fileFormat: 'PDF',
            expiryDate: '2025-09-15T23:59:59Z',
            status: 'expiring',
            addedAt: '2024-11-20T16:45:00Z'
        }
    ],
    5: [ // Arquivos de Viagem
        {
            id: 11,
            name: 'Passaporte - Ana Costa Silva',
            type: 'Passaporte',
            category: 'Arquivos de Viagem',
            fileSize: '2.8 MB',
            fileFormat: 'PDF',
            expiryDate: '2029-10-20T23:59:59Z',
            status: 'active',
            addedAt: '2024-12-05T11:00:00Z'
        },
        {
            id: 6,
            name: 'Carteira de Vacinação - Ana Costa',
            type: 'Carteira de Vacinação',
            category: 'Arquivos de Saúde',
            fileSize: '2.1 MB',
            fileFormat: 'PDF',
            expiryDate: null,
            status: 'active',
            addedAt: '2024-12-05T12:30:00Z'
        }
    ],
    'share_protected_123': [ // Documentos Empresariais - TechCorp LTDA
        {
            id: 1,
            name: 'CNH - João Silva Santos',
            type: 'CNH',
            category: 'Arquivos de Identidade',
            fileSize: '2.4 MB',
            fileFormat: 'PDF',
            expiryDate: '2027-03-15T23:59:59Z',
            status: 'active',
            addedAt: '2024-12-10T14:30:00Z'
        },
        {
            id: 12,
            name: 'RG - João Silva Santos',
            type: 'RG',
            category: 'Arquivos de Identidade',
            fileSize: '1.5 MB',
            fileFormat: 'JPG',
            expiryDate: '2034-10-25T23:59:59Z',
            status: 'active',
            addedAt: '2024-12-10T15:45:00Z'
        },
        {
            id: 13,
            name: 'CRLV - Veículo Fiat Toro',
            type: 'CRLV',
            category: 'Veículos',
            fileSize: '3.2 MB',
            fileFormat: 'PDF',
            expiryDate: '2026-09-25T23:59:59Z',
            status: 'active',
            addedAt: '2024-12-10T16:20:00Z'
        }
    ]
};

// ========================================
// LINKS DE UPLOAD DE TERCEIROS MOCK
// ========================================
export const mockUploadLinks = [
    {
        id: 1,
        title: 'Abertura Empresa - Restaurante Sabor Caseiro',
        description: 'Upload de documentos para abertura de LTDA: CPF/RG sócios, contratos e declarações',
        uploadUrl: 'https://filesave.com/upload/abertura-restaurante-sabor-caseiro',
        slugUrl: 'abertura-restaurante-sabor-caseiro',
        status: 'active',
        createdAt: '2024-11-15T08:30:00Z',
        expiryDate: '2024-12-20T23:59:59Z',
        stats: {
            views: 12,
            uploads: 6
        },
        settings: {
            maxFileSize: '25MB',
            allowedTypes: ['PDF', 'DOC', 'DOCX', 'JPG', 'PNG'],
            requireAuth: true,
            notifyEmail: true,
            requiredDocs: ['CPF Sócios', 'RG Sócios', 'Comprovante Residência', 'Contrato Locação']
        }
    },
    {
        id: 2,
        title: 'Fechamento Novembro 2024 - Loja Mania Fashion',
        description: 'Envio de notas fiscais, extratos e comprovantes para fechamento contábil',
        uploadUrl: 'https://filesave.com/upload/fechamento-nov24-mania-fashion',
        slugUrl: 'fechamento-nov24-mania-fashion',
        status: 'active',
        createdAt: '2024-12-01T14:20:00Z',
        expiryDate: '2024-12-10T23:59:59Z',
        stats: {
            views: 48,
            uploads: 32
        },
        settings: {
            maxFileSize: '50MB',
            allowedTypes: ['PDF', 'XLS', 'XLSX', 'XML', 'TXT'],
            requireAuth: false,
            notifyEmail: true,
            requiredDocs: ['Notas Fiscais Entrada', 'Notas Fiscais Saída', 'Extratos Bancários', 'Comprovantes Despesas']
        }
    },
    {
        id: 3,
        title: 'Auditoria RF - Distribuidora Central (URGENTE)',
        description: '🚨 URGENTE: Envio de livros contábeis, SPED e demonstrações para auditoria',
        uploadUrl: 'https://filesave.com/upload/auditoria-distribuidora-central',
        slugUrl: 'auditoria-distribuidora-central',
        status: 'active',
        createdAt: '2024-12-16T09:00:00Z',
        expiryDate: '2024-12-18T18:00:00Z',
        stats: {
            views: 267,
            uploads: 89
        },
        settings: {
            maxFileSize: '5MB',
            allowedTypes: ['PDF'],
            requireAuth: true,
            notifyEmail: true
        }
    },
    {
        id: 4,
        title: 'Contratos de Serviços - Consultoria ABC',
        description: 'Recebimento de contratos assinados pelos clientes',
        uploadUrl: 'https://filesave.com/upload/consultoria-abc/contratos-servicos',
        slugUrl: 'consultoria-abc-contratos-servicos',
        status: 'inactive',
        createdAt: '2024-11-25T16:45:00Z',
        expiryDate: '2025-05-25T23:59:59Z',
        stats: {
            views: 12,
            uploads: 3
        },
        settings: {
            maxFileSize: '15MB',
            allowedTypes: ['PDF', 'DOC', 'DOCX'],
            requireAuth: true,
            notifyEmail: true
        }
    },
    {
        id: 5,
        title: 'Certificados de Qualificação',
        description: 'Upload de certificados profissionais para validação',
        uploadUrl: 'https://filesave.com/upload/empresa-cert/certificados-qualificacao',
        slugUrl: 'empresa-cert-certificados-qualificacao',
        status: 'active',
        createdAt: '2024-12-03T09:15:00Z',
        expiryDate: '2025-06-03T23:59:59Z',
        stats: {
            views: 56,
            uploads: 18
        },
        settings: {
            maxFileSize: '8MB',
            allowedTypes: ['PDF', 'JPG', 'PNG'],
            requireAuth: false,
            notifyEmail: true
        }
    }
];

// ========================================
// PLANOS MOCK - DETALHADOS
// ========================================
export const mockPlans = [
	{
		id: 'essential',
		name: 'Essencial',
		icon: 'briefcase',
		description: 'Ideal para profissionais e pequenos negócios',
		price: { monthly: 89.00, yearly: 854.40 },
		annualDiscount: 0.20, // 20% de desconto anual
		featured: false,
		resources: {
			storage: 10, // GB
			sharingPages: 10,
			uploadPages: 10, 
			emailsSent: 100, // e-mails/mês
			alerts: 20, // alertas/mês
			// Limites máximos para recursos extras
			maxSharingPages: 50,
			maxUploadPages: 50,
			maxEmailsSent: 600,
			maxAlerts: 250
		},
		features: [
			{
				name: '10GB de armazenamento',
				description: 'Espaço seguro na nuvem para seus arquivos mais importantes',
				icon: 'database',
				included: true
			},
			{
				name: '2 páginas de compartilhamento',
				description: 'Crie até 2 páginas personalizadas para compartilhar arquivos',
				icon: 'share',
				included: true
			},
			{
				name: '2 páginas de upload',
				description: 'Configure até 2 formulários para terceiros enviarem arquivos',
				icon: 'upload',
				included: true
			},
			{
				name: 'Organização física',
				description: 'Organize por categorias como RG, CNH, Contratos',
				icon: 'user',
				included: true
			},
			{
				name: 'Alertas inteligentes',
				description: 'Receba notificações antes dos seus arquivos vencerem',
				icon: 'bell',
				included: true
			},
			{
				name: 'Compartilhamento seguro',
				description: 'Compartilhe arquivos com criptografia de ponta a ponta',
				icon: 'shield',
				included: true
			},
			{
				name: 'Lembretes recorrentes',
				description: 'Configure lembretes automáticos personalizados',
				icon: 'clock',
				included: true
			},
			{
				name: 'Busca por texto',
				description: 'Encontre arquivos rapidamente pelo conteúdo',
				icon: 'search',
				included: true
			},
			{
				name: 'Export PDF/Excel',
				description: 'Exporte relatórios e listas em diversos formatos',
				icon: 'download',
				included: true
			},
			{
				name: 'Acesso mobile',
				description: 'Acesse seus arquivos pelo smartphone ou tablet',
				icon: 'mobile',
				included: true
			},
			{
				name: 'Backup automático',
				description: 'Seus arquivos são salvos automaticamente',
				icon: 'shield',
				included: true
			},
			{
				name: 'Suporte por email',
				description: 'Atendimento por email em horário comercial',
				icon: 'question',
				included: true
			},
			{
				name: 'Templates básicos',
				description: 'Modelos pré-definidos para organização rápida de arquivos',
				icon: 'document',
				included: true,
				inDevelopment: true
			},
			{
				name: 'Histórico de 30 dias',
				description: 'Mantenha registro das atividades dos últimos 30 dias',
				icon: 'calendar',
				included: true,
				inDevelopment: true
			},
			{
				name: 'Integração Google Drive',
				description: 'Sincronize automaticamente com sua conta do Google Drive',
				icon: 'cloud',
				included: true,
				inDevelopment: true
			},
			{
				name: 'Notificações por email',
				description: 'Receba alertas importantes diretamente no seu email',
				icon: 'mail',
				included: true,
				inDevelopment: true
			},
			{
				name: 'Download em lote',
				description: 'Baixe múltiplos arquivos de uma vez',
				icon: 'cloud-download',
				included: true,
				inDevelopment: true
			},
			{
				name: 'Filtros avançados',
				description: 'Encontre arquivos por data, tipo, status e mais filtros',
				icon: 'filter',
				included: true,
				inDevelopment: true
			},
			{
				name: 'QR Code para acesso',
				description: 'Gere QR codes para acesso rápido aos seus arquivos',
				icon: 'qrcode',
				included: true,
				inDevelopment: true
			},
			{
				name: 'Categorias personalizadas',
				description: 'Crie suas próprias categorias para organizar arquivos',
				icon: 'bookmark',
				included: true,
				inDevelopment: true
			},
			{
				name: 'OCR automático',
				description: 'Reconhecimento automático de texto em imagens e PDFs',
				icon: 'eye',
				included: true,
				inDevelopment: true
			}
		]
	},
	{
		id: 'enterprise',
		name: 'Empresarial',
		icon: 'office',
		description: 'Perfeito para empresas e equipes',
		price: { monthly: 149.00, yearly: 1430.40 },
		annualDiscount: 0.20, // 20% de desconto anual
		featured: true,
		resources: {
			storage: 100, // GB
			sharingPages: 20,
			uploadPages: 20,
			emailsSent: 500, // e-mails/mês
			alerts: 100, // alertas/mês
			// Limites máximos para recursos extras
			maxStorage: 1000,
			maxSharingPages: 500,
			maxUploadPages: 500,
			maxEmailsSent: 10000,
			maxAlerts: 1000
		},
		features: [
			{
				name: 'Tudo do Essencial +',
				description: 'Todos os recursos do plano Essencial incluídos',
				icon: 'star-full',
				included: true,
				highlight: true
			},
			{
				name: '100GB de armazenamento',
				description: 'Amplo espaço para arquivos de toda sua empresa',
				icon: 'database',
				included: true
			},
			{
				name: '20 páginas de compartilhamento',
				description: 'Crie até 20 páginas personalizadas para compartilhar arquivos',
				icon: 'share',
				included: true
			},
			{
				name: '20 páginas de upload',
				description: 'Configure até 20 formulários para terceiros enviarem arquivos',
				icon: 'upload',
				included: true
			},
			{
				name: 'Organização jurídica',
				description: 'Classificação específica para arquivos empresariais e jurídicos',
				icon: 'office',
				included: true
			},
			{
				name: 'Link de upload para terceiros',
				description: 'Permita que outros enviem arquivos diretamente para você',
				icon: 'share',
				included: true
			},
			{
				name: 'Alerta para terceiros',
				description: 'Notifique outras pessoas sobre vencimentos importantes',
				icon: 'bell',
				included: true
			},
			{
				name: 'OCR automático',
				description: 'Reconhecimento automático de texto em imagens e PDFs',
				icon: 'eye',
				included: true
			},
			{
				name: 'API de integração',
				description: 'Integre com seus sistemas existentes via API REST',
				icon: 'terminal',
				included: true
			},
			{
				name: 'Usuários ilimitados',
				description: 'Adicione quantos usuários precisar sem custo extra',
				icon: 'users',
				included: true
			},
			{
				name: 'Assinatura digital',
				description: 'Assine arquivos digitalmente com validade jurídica',
				icon: 'pencil',
				included: true
			},
			{
				name: 'Auditoria completa',
				description: 'Histórico detalhado de todas as ações realizadas',
				icon: 'list',
				included: true
			},
			{
				name: 'Backup diário',
				description: 'Backup completo diário com versionamento',
				icon: 'shield',
				included: true
			},
			{
				name: 'Suporte prioritário 24/7',
				description: 'Atendimento prioritário 24 horas por dia, 7 dias por semana',
				icon: 'question',
				included: true
			},
			{
				name: 'Dashboard analytics',
				description: 'Relatórios e métricas sobre uso dos arquivos',
				icon: 'stats-bars',
				included: true
			},
			{
				name: 'White-label',
				description: 'Personalize com sua marca e identidade visual',
				icon: 'paint-format',
				included: true
			},
			{
				name: 'Templates avançados',
				description: 'Biblioteca completa de templates profissionais e personalizáveis',
				icon: 'document',
				included: true,
				inDevelopment: true
			},
			{
				name: 'Histórico ilimitado',
				description: 'Acesso completo a todo o histórico de atividades',
				icon: 'calendar',
				included: true,
				inDevelopment: true
			},
			{
				name: 'Multi-integrações',
				description: 'Conecte com Google Drive, Dropbox, OneDrive e mais',
				icon: 'cloud',
				included: true,
				inDevelopment: true
			},
			{
				name: 'Notificações multicanal',
				description: 'Email, SMS, WhatsApp e notificações push personalizadas',
				icon: 'mail',
				included: true,
				inDevelopment: true
			},
			{
				name: 'Automação de fluxos',
				description: 'Configure ações automáticas baseadas em regras',
				icon: 'settings',
				included: true,
				inDevelopment: true
			},
			{
				name: 'Relatórios avançados',
				description: 'Dashboards e relatórios detalhados com métricas',
				icon: 'pie-chart',
				included: true,
				inDevelopment: true
			},
			{
				name: 'Workflow personalizado',
				description: 'Crie fluxos de aprovação e validação personalizados',
				icon: 'tree',
				included: true,
				inDevelopment: true
			},
			{
				name: 'Certificados digitais',
				description: 'Emita e valide certificados digitais personalizados',
				icon: 'trophy',
				included: true,
				inDevelopment: true
			},
			{
				name: 'IA para categorização',
				description: 'Inteligência artificial classifica arquivos automaticamente',
				icon: 'magic-wand',
				included: true,
				inDevelopment: true
			},
			{
				name: 'Análise de sentimentos',
				description: 'Detecte automaticamente urgência e importância de arquivos',
				icon: 'heart',
				included: true,
				inDevelopment: true
			},
			{
				name: 'Export customizado',
				description: 'Exporte em qualquer formato com layouts personalizados',
				icon: 'download',
				included: true,
				inDevelopment: true
			},
			{
				name: 'Monitoramento 24/7',
				description: 'Monitoramento contínuo de segurança e performance',
				icon: 'shield',
				included: true,
				inDevelopment: true
			},
			{
				name: 'SLA garantido',
				description: 'Garantia de 99.9% de disponibilidade com SLA',
				icon: 'checkmark',
				included: true,
				inDevelopment: true
			},
			{
				name: 'Compliance LGPD',
				description: 'Total conformidade com a Lei Geral de Proteção de Dados',
				icon: 'lock',
				included: true
			}
		]
	}
];

export const mockFeatureComparisons = [
	{ feature: 'Arquivos ilimitados', essential: true, enterprise: true },
	{ feature: 'Armazenamento', essential: '10GB', enterprise: '100GB' },
	{ feature: 'Organização física', essential: true, enterprise: true },
	{ feature: 'Organização jurídica', essential: false, enterprise: true },
	{ feature: 'Alertas inteligentes', essential: true, enterprise: true },
	{ feature: 'Link de upload para terceiros', essential: false, enterprise: true },
	{ feature: 'OCR automático', essential: false, enterprise: true },
	{ feature: 'Suporte prioritário', essential: false, enterprise: true }
];

export const mockPlanFaqs = [
	{
		question: 'Posso cancelar a qualquer momento?',
		answer: 'Sim, você pode cancelar sua assinatura a qualquer momento sem taxas de cancelamento.'
	},
	{
		question: 'Como funciona o período de teste?',
		answer: 'Oferecemos 14 dias gratuitos para testar todos os recursos premium.'
	},
	{
		question: 'Meus dados estão seguros?',
		answer: 'Utilizamos criptografia de ponta a ponta e armazenamento em servidores seguros no Brasil.'
	},
	{
		question: 'Posso fazer upgrade do meu plano?',
		answer: 'Sim, você pode fazer upgrade a qualquer momento e pagar apenas a diferença proporcional.'
	}
];

// ========================================
// RECURSOS DOS PLANOS MOCK
// ========================================
export const mockPlanResources = {
	[PLAN_TYPES.FREE]: {
		storage: { used: 0.5, total: 1 },
		uploads: { used: 8, total: 10 },
		sends: { used: 5, total: 20 },
		alerts: { used: 3, total: 5 },
		sharePages: { used: 1, total: 2 },
		uploadPages: { used: 0, total: 1 }
	},
	[PLAN_TYPES.PERSONAL]: {
		storage: { used: 2.3, total: 10 },
		uploads: { used: 25, total: 50 },
		sends: { used: 15, total: 100 },
		alerts: { used: 8, total: 15 },
		sharePages: { used: 3, total: 5 },
		uploadPages: { used: 1, total: 3 }
	},
	[PLAN_TYPES.PROFESSIONAL]: {
		storage: { used: 15, total: 50 },
		uploads: { used: 45, total: 100 },
		sends: { used: 35, total: 250 },
		alerts: { used: 12, total: 25 },
		sharePages: { used: 6, total: 10 },
		uploadPages: { used: 3, total: 5 }
	},
	[PLAN_TYPES.ENTERPRISE]: {
		storage: { used: 120, total: 500 },
		uploads: { used: 180, total: 500 },
		sends: { used: 150, total: 1000 },
		alerts: { used: 25, total: 100 },
		sharePages: { used: 15, total: 50 },
		uploadPages: { used: 8, total: 20 }
	}
};

// ========================================
// CATEGORIAS DE DOCUMENTOS MOCK
// ========================================
export const mockFileCategories = {
	NATURAL: [
		// Categoria: Documentos de Identidade
		{
			value: 'cat_identidade',
			label: 'Documentos de Identidade',
			isCategory: true,
			suboptions: [
				{
					value: 'RG',
					label: 'RG'
				},
				{
					value: 'RNE',
					label: 'RNE (Registro Nacional de Estrangeiro)'
				},
				{
					value: 'CPF',
					label: 'CPF'
				},
				{
					value: 'CNH',
					label: 'CNH'
				},
				{
					value: 'Titulo_Eleitor',
					label: 'Título de Eleitor'
				},
				{
					value: 'Certidao_Nascimento',
					label: 'Certidão de Nascimento'
				},
				{
					value: 'Certidao_Casamento',
					label: 'Certidão de Casamento'
				},
				{
					value: 'Certidao_Obito',
					label: 'Certidão de Óbito'
				},
				{
					value: 'Carteira_Trabalho',
					label: 'Carteira de Trabalho Digital'
				},
				{
					value: 'Certificado_Reservista',
					label: 'Certificado de Reservista'
				},
				{
					value: 'Carteira_Profissional',
					label: 'Carteira de Identidade Profissional'
				}
			]
		},
		// Categoria: Documentos de Viagem
		{
			value: 'cat_viagem',
			label: 'Documentos de Viagem',
			isCategory: true,
			suboptions: [
				{
					value: 'Passaporte',
					label: 'Passaporte'
				},
				{
					value: 'Visto',
					label: 'Visto'
				},
				{
					value: 'Certificado_Vacinacao_Internacional',
					label: 'Certificado Internacional de Vacinação'
				}
			]
		},
		// Categoria: Documentos Previdenciários e Trabalhistas
		{
			value: 'cat_previdenciarios',
			label: 'Documentos Previdenciários e Trabalhistas',
			isCategory: true,
			suboptions: [
				{
					value: 'PIS_PASEP',
					label: 'PIS/PASEP/NIS'
				},
				{
					value: 'Cartao_INSS',
					label: 'Cartão do INSS'
				},
				{
					value: 'Extrato_FGTS',
					label: 'Extrato FGTS'
				},
				{
					value: 'Seguro_Desemprego',
					label: 'Seguro Desemprego'
				},
				{
					value: 'Extrato_Previdenciario',
					label: 'Extrato Previdenciário'
				},
				{
					value: 'Comprovante_INSS',
					label: 'Comprovante de Contribuição INSS'
				}
			]
		},
		// Categoria: Documentos de Saúde
		{
			value: 'cat_saude',
			label: 'Documentos de Saúde',
			isCategory: true,
			suboptions: [
				{
					value: 'Cartao_SUS',
					label: 'Cartão SUS'
				},
				{
					value: 'Exames_Medicos',
					label: 'Exames Médicos'
				},
				{
					value: 'Carteira_Vacinacao',
					label: 'Carteira de Vacinação'
				},
				{
					value: 'Carteirinha_Convenio',
					label: 'Carteirinha de Convênio Médico'
				},
				{
					value: 'Receitas_Medicas',
					label: 'Receitas Médicas'
				},
				{
					value: 'Atestados_Medicos',
					label: 'Atestados Médicos'
				},
				{
					value: 'Laudos_Medicos',
					label: 'Laudos Médicos'
				}
			]
		},
		// Categoria: Documentos Educacionais
		{
			value: 'cat_educacionais',
			label: 'Documentos Educacionais',
			isCategory: true,
			suboptions: [
				{
					value: 'Comprovante_Escolaridade',
					label: 'Comprovante de Escolaridade'
				},
				{
					value: 'Diplomas_Certificados',
					label: 'Diplomas e Certificados'
				},
				{
					value: 'Historico_Escolar',
					label: 'Histórico Escolar'
				},
				{
					value: 'Certificados_Tecnicos',
					label: 'Certificados de Cursos Técnicos/Superiores'
				},
				{
					value: 'Certificados_Cursos_Livres',
					label: 'Certificados de Cursos Livres'
				}
			]
		},
		// Categoria: Comprovantes Residenciais
		{
			value: 'cat_residenciais',
			label: 'Comprovantes Residenciais',
			isCategory: true,
			suboptions: [
				{
					value: 'Comprovante_Residencia',
					label: 'Comprovante de Residência'
				},
				{
					value: 'Comprovante_Renda',
					label: 'Comprovante de Renda'
				},
				{
					value: 'IPTU',
					label: 'IPTU'
				},
				{
					value: 'Contas_Consumo',
					label: 'Contas de Consumo'
				}
			]
		},
		// Categoria: Documentos Financeiros
		{
			value: 'cat_financeiros',
			label: 'Documentos Financeiros',
			isCategory: true,
			suboptions: [
				{
					value: 'Contrato_Aluguel',
					label: 'Contrato de Aluguel'
				},
				{
					value: 'Contrato_Trabalho',
					label: 'Contrato de Trabalho'
				},
				{
					value: 'Notas_Fiscais_Pessoais',
					label: 'Notas Fiscais Pessoais'
				},
				{
					value: 'Extratos_Bancarios',
					label: 'Extratos Bancários'
				},
				{
					value: 'Contratos_Emprestimo',
					label: 'Contratos de Empréstimo/Financiamento'
				},
				{
					value: 'Cartoes_Credito',
					label: 'Cartões de Crédito'
				},
				{
					value: 'Investimentos',
					label: 'Investimentos'
				}
			]
		},
		// Categoria: Documentos Imobiliários
		{
			value: 'cat_imobiliarios',
			label: 'Documentos Imobiliários',
			isCategory: true,
			suboptions: [
				{
					value: 'Escritura_Imovel',
					label: 'Escritura de Imóvel'
				},
				{
					value: 'Certidao_Negativa_Imoveis',
					label: 'Certidão Negativa de Débitos Imobiliários'
				},
				{
					value: 'Contratos_Compra_Venda',
					label: 'Contratos de Compra e Venda'
				},
				{
					value: 'Registro_Imoveis',
					label: 'Registro de Imóveis'
				}
			]
		},
		// Categoria: Documentos de Veículos
		{
			value: 'cat_veiculos',
			label: 'Documentos de Veículos',
			isCategory: true,
			suboptions: [
				{
					value: 'CRLV',
					label: 'CRLV'
				},
				{
					value: 'Seguro_Veicular',
					label: 'Seguro Veicular'
				},
				{
					value: 'CNH_Digital',
					label: 'CNH Digital'
				},
				{
					value: 'IPVA',
					label: 'IPVA'
				},
				{
					value: 'Multas_Transito',
					label: 'Multas de Trânsito'
				}
			]
		},
		// Categoria: Documentos Familiares
		{
			value: 'cat_familiares',
			label: 'Documentos Familiares',
			isCategory: true,
			suboptions: [
				{
					value: 'Certidao_Casamento_Divorcio',
					label: 'Certidão de Casamento/Divórcio'
				},
				{
					value: 'Documentos_Filhos',
					label: 'Documentos dos Filhos'
				},
				{
					value: 'Procuracao',
					label: 'Procuração'
				},
				{
					value: 'Testamento',
					label: 'Testamento'
				},
				{
					value: 'Inventario',
					label: 'Inventário'
				}
			]
		},
		// Categoria: Outros Documentos (SEM SUBCATEGORIAS)
		{
			value: 'cat_outros',
			label: 'Outros Documentos'
		}
	],
	COMPANY: [
		// Categoria: Documentos Pessoais dos Sócios
		{
			value: 'cat_documentos_socios',
			label: 'Documentos Pessoais dos Sócios',
			isCategory: true,
			suboptions: [
				{ value: 'RG_Socios', label: 'RG dos Sócios' },
				{ value: 'CPF_Socios', label: 'CPF dos Sócios' },
				{ value: 'CNH_Socios', label: 'CNH dos Sócios' },
				{ value: 'Comprovante_Residencia_Socios', label: 'Comprovante de Residência dos Sócios' },
				{ value: 'Certidoes_Socios', label: 'Certidões dos Sócios' },
				{ value: 'Declaracao_IR_Socios', label: 'Declaração IR dos Sócios' },
				{ value: 'Qualificacao_Socios', label: 'Qualificação dos Sócios' },
				{ value: 'Procuracao_Socios', label: 'Procuração dos Sócios' },
				{ value: 'Carteira_Profissional_Socios', label: 'Carteira Profissional dos Sócios' }
			]
		},
		// Categoria: Documentos de Registro e Constituição
		{
			value: 'cat_registro_constituicao',
			label: 'Documentos de Registro e Constituição',
			isCategory: true,
			suboptions: [
				{ value: 'CNPJ', label: 'CNPJ' },
				{ value: 'Contrato_Social', label: 'Contrato Social / Estatuto' },
				{ value: 'Alteracoes_Contratuais', label: 'Alterações Contratuais' },
				{ value: 'Inscricao_Estadual', label: 'Inscrição Estadual' },
				{ value: 'Inscricao_Municipal', label: 'Inscrição Municipal' },
				{ value: 'Ficha_Breve_Relato', label: 'Ficha de Breve Relato (FCN)' },
				{ value: 'Certificado_MEI', label: 'Certificado de MEI' }
			]
		},
		// Categoria: Documentos Societários
		{
			value: 'cat_societarios',
			label: 'Documentos Societários',
			isCategory: true,
			suboptions: [
				{ value: 'Ata_Assembleia', label: 'Ata de Assembleia/Reunião de Sócios' },
				{ value: 'Livro_Atas', label: 'Livro de Atas' },
				{ value: 'Acordo_Quotistas', label: 'Acordo de Quotistas' },
				{ value: 'Termo_Posse', label: 'Termo de Posse de Administradores' },
				{ value: 'Procuracao_Empresarial', label: 'Procuração Empresarial' }
			]
		},
		// Categoria: Documentos Tributários
		{
			value: 'cat_tributarios',
			label: 'Documentos Tributários',
			isCategory: true,
			suboptions: [
				{ value: 'Certidoes_Negativas', label: 'Certidões Negativas' },
				{ value: 'DARF_GPS', label: 'DARF e GPS' },
				{ value: 'ECF', label: 'ECF - Escrituração Contábil Fiscal' },
				{ value: 'SPED', label: 'SPED Fiscal/Contábil' },
				{ value: 'IRPJ', label: 'Declaração de Imposto de Renda PJ' },
				{ value: 'DEFIS', label: 'DEFIS' },
				{ value: 'DAS', label: 'DAS (Simples Nacional)' }
			]
		},
		// Categoria: Documentos Trabalhistas e Previdenciários
		{
			value: 'cat_trabalhistas',
			label: 'Documentos Trabalhistas e Previdenciários',
			isCategory: true,
			suboptions: [
				{ value: 'Contratos_Trabalho', label: 'Contratos de Trabalho' },
				{ value: 'Carteira_Trabalho_Digital', label: 'Carteira de Trabalho Digital' },
				{ value: 'Ficha_Cadastral', label: 'Ficha Cadastral de Colaboradores' },
				{ value: 'eSocial', label: 'eSocial' },
				{ value: 'CAGED', label: 'CAGED' },
				{ value: 'DIRF', label: 'DIRF' },
				{ value: 'GFIP', label: 'GFIP' },
				{ value: 'Folha_Pagamento', label: 'Folha de Pagamento' },
				{ value: 'RAIS', label: 'RAIS' }
			]
		},
		// Categoria: Documentos Financeiros e Contábeis
		{
			value: 'cat_financeiros_contabeis',
			label: 'Documentos Financeiros e Contábeis',
			isCategory: true,
			suboptions: [
				{ value: 'Notas_Fiscais', label: 'Notas Fiscais' },
				{ value: 'Demonstrativos_Contabeis', label: 'Demonstrativos Contábeis' },
				{ value: 'Contratos_Emprestimo_PJ', label: 'Contratos de Empréstimo/Financiamento' },
				{ value: 'Extratos_Bancarios_PJ', label: 'Extratos Bancários Corporativos' },
				{ value: 'Fluxo_Caixa', label: 'Demonstrativo de Fluxo de Caixa' },
				{ value: 'Contratos_Leasing', label: 'Contratos de Leasing' },
				{ value: 'Livro_Caixa', label: 'Livro Caixa' },
				{ value: 'Conciliacao_Bancaria', label: 'Conciliação Bancária' }
			]
		},
		// Categoria: Licenças e Autorizações
		{
			value: 'cat_licencas',
			label: 'Licenças e Autorizações',
			isCategory: true,
			suboptions: [
				{ value: 'Alvara_Funcionamento', label: 'Alvarás de Funcionamento' },
				{ value: 'Certificados_Ambientais', label: 'Certificados Ambientais/Sanitários' },
				{ value: 'Certificados_Seguranca', label: 'Certificados de Segurança' },
				{ value: 'Licenca_Ambiental', label: 'Licença Ambiental' },
				{ value: 'Certificado_Digital', label: 'Certificado Digital' },
				{ value: 'Licenca_Sanitaria', label: 'Licença Sanitária' },
				{ value: 'Registro_Bombeiros', label: 'Registro no Corpo de Bombeiros' },
				{ value: 'Habite_se', label: 'Habite-se' }
			]
		},
		// Categoria: Certificações de Qualidade
		{
			value: 'cat_certificacoes',
			label: 'Certificações de Qualidade',
			isCategory: true,
			suboptions: [
				{ value: 'ISO_Certificacoes', label: 'ISO/Certificações de Qualidade' },
				{ value: 'Certificados_Setoriais', label: 'Certificados Setoriais' },
				{ value: 'Auditorias_Externas', label: 'Auditorias Externas' }
			]
		},
		// Categoria: Contratos e Acordos
		{
			value: 'cat_contratos',
			label: 'Contratos e Acordos',
			isCategory: true,
			suboptions: [
				{ value: 'Contratos_Fornecedores', label: 'Contratos com Fornecedores' },
				{ value: 'Contratos_Clientes', label: 'Contratos com Clientes' },
				{ value: 'Acordos_Parceria', label: 'Acordos de Parceria' },
				{ value: 'Contratos_Prestacao_Servicos', label: 'Contratos de Prestação de Serviços' },
				{ value: 'Termos_Confidencialidade', label: 'Termos de Confidencialidade' },
				{ value: 'Contratos_Distribuicao', label: 'Contratos de Distribuição' }
			]
		},
		// Categoria: Propriedade Intelectual
		{
			value: 'cat_propriedade_intelectual',
			label: 'Propriedade Intelectual',
			isCategory: true,
			suboptions: [
				{ value: 'Registro_Marca', label: 'Registro de Marca' },
				{ value: 'Patentes', label: 'Patentes' },
				{ value: 'Direitos_Autorais', label: 'Direitos Autorais' },
				{ value: 'Contratos_Licenciamento', label: 'Contratos de Licenciamento' },
				{ value: 'Registro_Software', label: 'Registro de Software' },
				{ value: 'Desenho_Industrial', label: 'Desenho Industrial' }
			]
		},
		// Categoria: Documentos de Importação/Exportação
		{
			value: 'cat_importacao_exportacao',
			label: 'Documentos de Importação/Exportação',
			isCategory: true,
			suboptions: [
				{ value: 'Declaracao_Importacao', label: 'Declaração de Importação' },
				{ value: 'Registro_Exportacao', label: 'Registro de Exportação' },
				{ value: 'Certificado_Origem', label: 'Certificado de Origem' },
				{ value: 'SISCOMEX', label: 'SISCOMEX' },
				{ value: 'Licencas_Importacao', label: 'Licenças de Importação' },
				{ value: 'Conhecimento_Embarque', label: 'Conhecimento de Embarque' }
			]
		},
		// Categoria: Seguros Empresariais
		{
			value: 'cat_seguros',
			label: 'Seguros Empresariais',
			isCategory: true,
			suboptions: [
				{ value: 'Seguro_Responsabilidade_Civil', label: 'Seguro Responsabilidade Civil' },
				{ value: 'Seguro_Vida_Grupo', label: 'Seguro de Vida em Grupo' },
				{ value: 'DO_Seguro', label: 'D&O (Diretores e Administradores)' },
				{ value: 'Apolices_Seguro_Bens', label: 'Apólices de Seguro de Bens' },
				{ value: 'Seguro_Produtos', label: 'Seguro de Produtos/Serviços' }
			]
		},
		// Categoria: Documentos Imobiliários Empresariais
		{
			value: 'cat_imobiliarios_empresariais',
			label: 'Documentos Imobiliários Empresariais',
			isCategory: true,
			suboptions: [
				{ value: 'Contrato_Locacao_Comercial', label: 'Contrato de Locação Comercial' },
				{ value: 'IPTU_Corporativo', label: 'IPTU de Imóveis Corporativos' },
				{ value: 'Registro_Imoveis_Comerciais', label: 'Registro de Imóveis' },
				{ value: 'Documentos_Frota', label: 'Documentos de Frota' },
				{ value: 'Escritura_Imoveis_Comerciais', label: 'Escritura de Imóveis Comerciais' }
			]
		},
		// Categoria: Documentos Setoriais Específicos
		{
			value: 'cat_setoriais',
			label: 'Documentos Setoriais Específicos',
			isCategory: true,
			suboptions: [
				{ value: 'Registros_Profissionais_PJ', label: 'Registros Profissionais' },
				{ value: 'Licencas_Setoriais', label: 'Licenças Específicas do Setor' },
				{ value: 'Certificados_Conformidade', label: 'Certificados de Conformidade' },
				{ value: 'Laudos_Tecnicos', label: 'Laudos Técnicos' }
			]
		},
		// Categoria: Outros Documentos Corporativos (SEM SUBCATEGORIAS)
		{
			value: 'cat_outros_corporativos',
			label: 'Outros Documentos Corporativos'
		}
	]
};

// ========================================
// GRUPOS DE DOCUMENTOS MOCK
// ========================================
export const mockFileGroups = [
	{ value: 'pessoal', label: 'Pessoal' },
	{ value: 'trabalho', label: 'Trabalho' },
	{ value: 'familia', label: 'Família' },
	{ value: 'financeiro', label: 'Financeiro' },
	{ value: 'saude', label: 'Saúde' },
	{ value: 'educacao', label: 'Educação' },
	{ value: 'juridico', label: 'Jurídico' },
	{ value: 'empresa', label: 'Empresa' },
	{ value: 'imoveis', label: 'Imóveis' },
	{ value: 'veiculos', label: 'Veículos' }
];

// ========================================
// MOCK DATA PARA AUTOMAÇÃO DE EMAIL
// ========================================
export const mockAutomationDefaults = {
	name: 'Envio Mensal de Documentos',
	description: 'Envio automático dos documentos mais importantes para os clientes',
	active: true,
	frequency: 'monthly',
	time: '09:00',
	date: '',
	weekdays: ['monday', 'wednesday', 'friday'],
	monthlyType: 'day',
	monthDay: 15,
	fileSelectionType: 'type',
	fileSelectionValue: ['CNH', 'RG', 'CPF'],
	recipients: ['cliente@exemplo.com', 'contato@empresa.com'],
	emailSubject: 'Documentos - Envio Automático Mensal',
	emailMessage: 'Prezado(a),\n\nSegue em anexo seus documentos atualizados.\n\nAtenciosamente,\nEquipe FileSave'
};

// ========================================
// MOCK API PARA AUTOMAÇÃO
// ========================================
export const mockAutomationApi = {
	// Simular carregamento de dados de automação
	async loadAutomationData(automationId) {
		await new Promise(resolve => setTimeout(resolve, 800));

		if (automationId === 'new') {
			return mockAutomationDefaults;
		}

		// Retorna dados de uma automação existente
		return {
			...mockAutomationDefaults,
			id: automationId,
			name: 'Envio Semanal de Contratos',
			frequency: 'weekly',
			weekdays: ['tuesday', 'thursday'],
			fileSelectionType: 'category',
			fileSelectionValue: ['trabalho', 'juridico'],
			createdAt: '2024-01-15T10:30:00Z',
			updatedAt: '2024-03-20T14:45:00Z'
		};
	},

	// Simular salvamento de automação
	async saveAutomation(automationData) {
		await new Promise(resolve => setTimeout(resolve, 1200));

		// Simular falha ocasional
		if (Math.random() < 0.1) {
			throw new Error('Erro no servidor. Tente novamente.');
		}

		return {
			success: true,
			data: {
				...automationData,
				id: automationData.id || Date.now().toString(),
				createdAt: automationData.createdAt || new Date().toISOString(),
				updatedAt: new Date().toISOString()
			},
			message: automationData.id ? 'Automação atualizada com sucesso!' : 'Automação criada com sucesso!'
		};
	},

	// Simular validação de emails
	async validateEmails(emails) {
		await new Promise(resolve => setTimeout(resolve, 300));

		const invalidEmails = emails.filter(email => !email.includes('@') || !email.includes('.'));

		return {
			valid: invalidEmails.length === 0,
			invalidEmails: invalidEmails,
			message: invalidEmails.length > 0 ? 'Alguns emails são inválidos' : 'Todos os emails são válidos'
		};
	}
};

// ========================================
// CLIENTES PARA FILTROS MOCK
// ========================================
export const mockClientFilters = [
	{ value: 'restaurante-sabor-caseiro', label: 'Restaurante Sabor Caseiro Ltda.' },
	{ value: 'loja-mania-fashion', label: 'Loja Mania Fashion ME' },
	{ value: 'distribuidora-central', label: 'Distribuidora Central S.A.' },
	{ value: 'oficina-irmaos', label: 'Oficina Mecânica dos Irmãos' },
	{ value: 'transportadora-rapida', label: 'Transportadora Rápida Ltda.' },
	{ value: 'padaria-pao-dourado', label: 'Padaria Pão Dourado Eireli' },
	{ value: 'consultorio-medico-silva', label: 'Consultório Dr. Silva & Associados' },
	{ value: 'mercado-bom-preco', label: 'Mercado Bom Preço Ltda.' }
];

// ========================================
// TIPOS DE DOCUMENTO PERSONALIZADOS MOCK
// ========================================
export const mockDocumentTypes = [
	{
		name: 'CNH',
		count: 12,
		stats: { expiring: 2, expired: 0 }
	},
	{
		name: 'RG',
		count: 15,
		stats: { expiring: 1, expired: 0 }
	},
	{
		name: 'CPF',
		count: 18,
		stats: { expiring: 0, expired: 0 }
	},
	{
		name: 'CNPJ',
		count: 25,
		stats: { expiring: 2, expired: 1 }
	},
	{
		name: 'Notas Fiscais de Entrada',
		count: 847,
		stats: { expiring: 15, expired: 2 }
	},
	{
		name: 'Extratos Bancários',
		count: 234,
		stats: { expiring: 8, expired: 1 }
	},
	{
		name: 'Livro Diário',
		count: 28,
		stats: { expiring: 1, expired: 0 }
	},
	{
		name: 'Folha de Pagamento',
		count: 48,
		stats: { expiring: 3, expired: 0 }
	},
	{
		name: 'DARF',
		count: 156,
		stats: { expiring: 12, expired: 3 }
	},
	{
		name: 'ECF',
		count: 22,
		stats: { expiring: 0, expired: 0 }
	},
	{
		name: 'Contrato Social',
		count: 35,
		stats: { expiring: 2, expired: 0 }
	},
	{
		name: 'GPS',
		count: 87,
		stats: { expiring: 8, expired: 1 }
	},
	{
		name: 'Balanço Patrimonial',
		count: 16,
		stats: { expiring: 1, expired: 0 }
	},
	{
		name: 'Alvará',
		count: 5,
		stats: { expiring: 1, expired: 0 }
	},
	{
		name: 'Contrato de Aluguel',
		count: 8,
		stats: { expiring: 2, expired: 0 }
	},
	{
		name: 'Comprovante de Residência',
		count: 22,
		stats: { expiring: 3, expired: 1 }
	}
];

// ========================================
// DOCUMENTOS DISPONÍVEIS PARA COMPARTILHAMENTO
// ========================================
export const mockAvailableDocuments = [
    { id: 1, name: 'NFe Nov24 - Completas.pdf', type: 'Notas Fiscais de Entrada', category: 'Documentos Fiscais - Restaurantes', client: 'restaurante-sabor-caseiro', size: '15.2 MB', icon: 'file-text', status: 'active', statusLabel: 'Entregue' },
    { id: 2, name: 'Extratos BB Nov24.pdf', type: 'Extratos Bancários', category: 'Documentos Bancários - Varejo', client: 'loja-mania-fashion', size: '3.4 MB', icon: 'credit-card', status: 'expiring', statusLabel: 'Vence 15/12', expiryDate: '2025-12-15T23:59:59Z' },
    { id: 3, name: 'Livro Diário 2024.pdf', type: 'Livro Diário', category: 'Escrituração Contábil - Distribuidoras', client: 'distribuidora-central', size: '28.7 MB', icon: 'book', status: 'active', statusLabel: 'OK' },
    { id: 4, name: 'Folha Pagto Dez24.pdf', type: 'Folha de Pagamento', category: 'Recursos Humanos - Transportadoras', client: 'transportadora-rapida', size: '6.8 MB', icon: 'users', status: 'expiring', statusLabel: 'Vence 20/01', expiryDate: '2025-01-20T23:59:59Z' },
    { id: 5, name: 'DARFs IRPJ 2024.pdf', type: 'DARF', category: 'Impostos e Tributos - Oficinas', client: 'oficina-irmaos', size: '2.1 MB', icon: 'file-text', status: 'expiring', statusLabel: 'Vence 31/03', expiryDate: '2025-03-31T23:59:59Z' },
    { id: 6, name: 'ECF Transmitida.xml', type: 'ECF', category: 'Escrituração Digital - SPED', client: 'oficina-irmaos', size: '5.7 MB', icon: 'code', status: 'active', statusLabel: 'Transmitida' },
    { id: 7, name: 'Contrato Social Alterado.pdf', type: 'Contrato Social', category: 'Documentos Societários - Padarias', client: 'padaria-pao-dourado', size: '4.8 MB', icon: 'file-text', status: 'active', statusLabel: 'Aprovado', expiryDate: '2025-06-15T23:59:59Z' },
    { id: 8, name: 'GPS INSS Dez24.pdf', type: 'GPS', category: 'Guias de Recolhimento - INSS/FGTS', client: 'transportadora-rapida', size: '1.2 MB', icon: 'file-text', status: 'expiring', statusLabel: 'Vence 20/01', expiryDate: '2025-01-20T23:59:59Z' },
    { id: 9, name: 'CNH João Silva.pdf', type: 'CNH', category: 'Documentos Pessoais', client: null, size: '2.5 MB', icon: 'credit-card', status: 'expiring', statusLabel: 'Vence 15/02', expiryDate: '2025-02-15T23:59:59Z' },
    { id: 10, name: 'IPVA Veículo ABC-1234.pdf', type: 'IPVA', category: 'Documentos Veiculares', client: null, size: '1.8 MB', icon: 'credit-card', status: 'expiring', statusLabel: 'Vence 31/05', expiryDate: '2025-05-31T23:59:59Z' }
];

// ========================================
// OPÇÕES DE CLIENTES
// ========================================
export const mockClientOptions = [
    { value: 'restaurante-sabor-caseiro', label: 'Restaurante Sabor Caseiro Ltda.' },
    { value: 'loja-mania-fashion', label: 'Loja Mania Fashion ME' },
    { value: 'distribuidora-central', label: 'Distribuidora Central S.A.' },
    { value: 'oficina-irmaos', label: 'Oficina Mecânica dos Irmãos' },
    { value: 'transportadora-rapida', label: 'Transportadora Rápida Ltda.' },
    { value: 'padaria-pao-dourado', label: 'Padaria Pão Dourado Eireli' }
];

// ========================================
// OPÇÕES DE FILTRO DE CLIENTES
// ========================================
export const mockDocumentClientOptions = [
    { value: '', label: 'Todos os clientes' },
    ...mockClientOptions
];

// ========================================
// OPÇÕES DE CATEGORIAS DE DOCUMENTOS
// ========================================
export const mockDocumentCategoryOptions = [
    { value: 'Pessoal', label: 'Pessoal' },
    { value: 'Financeiro', label: 'Financeiro' },
    { value: 'Profissional', label: 'Profissional' },
    { value: 'Acadêmico', label: 'Acadêmico' },
    { value: 'Empresarial', label: 'Empresarial' }
];

// ========================================
// ROADMAP MOCK
// ========================================
export const mockRoadmapItems = [
    {
        id: 1,
        title: 'Integração com WhatsApp',
        description: 'Receba notificações de vencimento diretamente no WhatsApp para nunca perder um prazo importante.',
        category: 'Comunicação',
        status: 'development',
        votes: 142,
        hasVoted: false,
        comments: [
            {
                id: 1,
                author: 'Maria Silva',
                text: 'Essa funcionalidade seria perfeita! Uso muito mais o WhatsApp que email.',
                date: new Date('2024-12-10T14:30:00Z')
            },
            {
                id: 2,
                author: 'João Santos',
                text: 'Concordo! E seria legal se pudesse escolher qual tipo de documento quer receber notificação.',
                date: new Date('2024-12-11T09:15:00Z')
            }
        ]
    },
    {
        id: 2,
        title: 'Aplicativo Mobile',
        description: 'Tenha todos os seus documentos na palma da mão com nosso app nativo para iOS e Android.',
        category: 'Mobile',
        status: 'analysis',
        votes: 289,
        hasVoted: true,
        comments: [
            {
                id: 3,
                author: 'Carlos Oliveira',
                text: 'Muito necessário! Preciso acessar meus documentos quando estou fora de casa.',
                date: new Date('2024-12-09T16:45:00Z')
            },
            {
                id: 4,
                author: 'Ana Costa',
                text: 'Tomara que tenha reconhecimento por impressão digital para segurança.',
                date: new Date('2024-12-12T11:20:00Z')
            }
        ]
    },
    {
        id: 3,
        title: 'Scanner de Documentos',
        description: 'Escaneie documentos físicos diretamente pelo navegador ou aplicativo usando a câmera do dispositivo.',
        category: 'Digitalização',
        status: 'planned',
        votes: 76,
        hasVoted: false,
        comments: [
            {
                id: 5,
                author: 'Pedro Lima',
                text: 'Seria incrível não precisar de scanner físico! A qualidade fica boa?',
                date: new Date('2024-12-08T13:10:00Z')
            }
        ]
    },
    {
        id: 4,
        title: 'Modo Offline',
        description: 'Acesse seus documentos mesmo sem conexão com a internet, com sincronização automática.',
        category: 'Acesso',
        status: 'planned',
        votes: 203,
        hasVoted: false,
        comments: []
    },
    {
        id: 5,
        title: 'Compartilhamento por QR Code',
        description: 'Compartilhe documentos facilmente através de QR codes para acesso rápido e seguro.',
        category: 'Compartilhamento',
        status: 'available',
        votes: 95,
        hasVoted: true,
        comments: [
            {
                id: 6,
                author: 'Lucia Ferreira',
                text: 'Já está funcionando e é muito prático! Uso sempre para mostrar meus documentos.',
                date: new Date('2024-12-13T10:05:00Z')
            }
        ]
    },
    {
        id: 6,
        title: 'Inteligência Artificial para Categorização',
        description: 'IA que identifica automaticamente o tipo de documento e sugere a melhor organização.',
        category: 'Automação',
        status: 'development',
        votes: 167,
        hasVoted: false,
        comments: [
            {
                id: 7,
                author: 'Roberto Silva',
                text: 'Isso vai economizar muito tempo! Não vou precisar categorizar manualmente.',
                date: new Date('2024-12-07T15:30:00Z')
            },
            {
                id: 8,
                author: 'Fernanda Costa',
                text: 'Espero que consiga ler documentos em qualquer qualidade de imagem.',
                date: new Date('2024-12-11T14:45:00Z')
            }
        ]
    },
    {
        id: 7,
        title: 'Backup Automático na Nuvem',
        description: 'Backup automático de todos os seus documentos com múltiplas cópias de segurança.',
        category: 'Segurança',
        status: 'available',
        votes: 134,
        hasVoted: false,
        comments: [
            {
                id: 9,
                author: 'Marcos Santos',
                text: 'Fundamental para ter tranquilidade! Nunca mais vou perder um documento.',
                date: new Date('2024-12-12T08:20:00Z')
            }
        ]
    },
    {
        id: 8,
        title: 'Assinatura Digital',
        description: 'Assine documentos digitalmente com validade jurídica, sem precisar imprimir.',
        category: 'Jurídico',
        status: 'analysis',
        votes: 256,
        hasVoted: true,
        comments: [
            {
                id: 10,
                author: 'Juliana Oliveira',
                text: 'Perfeito para contratos! Vai facilitar muito o trabalho remoto.',
                date: new Date('2024-12-10T12:15:00Z')
            }
        ]
    },
    {
        id: 9,
        title: 'Integração com Órgãos Públicos',
        description: 'Conecte-se diretamente com Detran, Receita Federal e outros órgãos para atualização automática.',
        category: 'Governo',
        status: 'planned',
        votes: 312,
        hasVoted: false,
        comments: [
            {
                id: 11,
                author: 'Eduardo Lima',
                text: 'Isso seria revolucionário! Não precisar ir em lugares para pegar documento.',
                date: new Date('2024-12-09T17:40:00Z')
            },
            {
                id: 12,
                author: 'Patricia Santos',
                text: 'Tomara que integre com o eSocial também para documentos trabalhistas.',
                date: new Date('2024-12-11T09:30:00Z')
            }
        ]
    },
    {
        id: 10,
        title: 'Dashboard Avançado de Relatórios',
        description: 'Visualize estatísticas detalhadas sobre seus documentos, vencimentos e histórico de uso.',
        category: 'Análise',
        status: 'available',
        votes: 89,
        hasVoted: false,
        comments: []
    }
];

// ========================================
// NOVIDADES MOCK
// ========================================
export const mockNewsUpdates = [
    {
        id: 1,
        type: 'feature',
        title: 'Integração com WhatsApp Business',
        description: 'Agora você pode receber notificações de vencimento diretamente no WhatsApp. Configure alertas personalizados e nunca mais perca um prazo importante.',
        date: new Date('2024-12-15T10:00:00Z'),
        features: [
            'Notificações personalizadas por tipo de documento',
            'Mensagens automáticas 30, 15 e 7 dias antes do vencimento',
            'Confirmação de leitura integrada',
            'Suporte a múltiplos números'
        ],
        reactions: { like: 45, celebrate: 23 },
        userReaction: null
    },
    {
        id: 2,
        type: 'improvement',
        title: 'Nova Interface de Upload',
        description: 'Redesenhamos completamente a experiência de upload de documentos. Agora é mais rápido, intuitivo e com melhor feedback visual.',
        date: new Date('2024-12-12T14:30:00Z'),
        features: [
            'Drag & drop aprimorado com preview',
            'Categorização automática por IA',
            'Upload em lote até 50 arquivos',
            'Barra de progresso individual por arquivo'
        ],
        reactions: { like: 67, celebrate: 34 },
        userReaction: 'like'
    },
    {
        id: 3,
        type: 'security',
        title: 'Criptografia de Ponta a Ponta',
        description: 'Implementamos criptografia AES-256 para todos os documentos. Seus arquivos agora são protegidos com o mesmo padrão usado por bancos.',
        date: new Date('2024-12-08T09:15:00Z'),
        features: [
            'Criptografia AES-256 para todos os arquivos',
            'Chaves únicas por usuário',
            'Backup criptografado em múltiplos data centers',
            'Certificação ISO 27001 obtida'
        ],
        reactions: { like: 89, celebrate: 56 },
        userReaction: 'celebrate'
    },
    {
        id: 4,
        type: 'bug',
        title: 'Melhorias de Performance',
        description: 'Otimizamos o carregamento da plataforma. Agora tudo é 40% mais rápido, especialmente em dispositivos móveis.',
        date: new Date('2024-12-05T16:45:00Z'),
        features: [
            'Carregamento 40% mais rápido',
            'Cache inteligente de documentos',
            'Compressão otimizada de imagens',
            'Interface responsiva aprimorada'
        ],
        reactions: { like: 32, celebrate: 18 },
        userReaction: null
    }
];

export const mockRoadmapQuarters = [
    {
        id: 1,
        period: 'Próximas Semanas',
        theme: 'Recursos em Desenvolvimento',
        description: 'Funcionalidades que nossa equipe está finalizando para você.',
        features: [
            {
                id: 101,
                title: 'Integração com WhatsApp',
                description: 'Receba alertas de vencimento diretamente no WhatsApp para nunca perder um prazo.',
                category: 'Comunicação',
                status: 'development',
                votes: 234
            },
            {
                id: 102,
                title: 'Inteligência Artificial para Categorização',
                description: 'IA que identifica automaticamente o tipo de documento e organiza para você.',
                category: 'Automação',
                status: 'development',
                votes: 189
            }
        ]
    },
    {
        id: 2,
        period: 'Próximos Meses',
        theme: 'Grandes Novidades Chegando',
        description: 'Recursos incríveis que estamos planejando com muito carinho.',
        features: [
            {
                id: 201,
                title: 'App para Celular',
                description: 'Aplicativo completo para iPhone e Android para acessar seus documentos em qualquer lugar.',
                category: 'Mobile',
                status: 'analysis',
                votes: 445
            },
            {
                id: 202,
                title: 'Funciona Sem Internet',
                description: 'Acesse seus documentos mesmo offline, com sincronização automática quando voltar online.',
                category: 'Acesso',
                status: 'analysis',
                votes: 298
            },
            {
                id: 203,
                title: 'Scanner Pelo Celular',
                description: 'Fotografe documentos com seu celular e transforme em arquivos organizados automaticamente.',
                category: 'Digitalização',
                status: 'planned',
                votes: 167
            },
            {
                id: 204,
                title: 'Assinatura Digital',
                description: 'Assine documentos digitalmente direto na plataforma com validade jurídica.',
                category: 'Jurídico',
                status: 'planned',
                votes: 312
            }
        ]
    },
    {
        id: 3,
        period: 'Futuro Próximo',
        theme: 'Conectando com o Mundo',
        description: 'Integrações que vão revolucionar como você lida com documentos oficiais.',
        features: [
            {
                id: 301,
                title: 'Conexão com Órgãos Públicos',
                description: 'Acesse CNH, CPF, CNPJ e outros documentos diretamente dos órgãos oficiais.',
                category: 'Governo',
                status: 'planned',
                votes: 567
            },
            {
                id: 302,
                title: 'Backup Automático na Nuvem',
                description: 'Seus documentos sempre seguros com múltiplas cópias automáticas.',
                category: 'Segurança',
                status: 'planned',
                votes: 234
            },
            {
                id: 303,
                title: 'Compartilhamento por QR Code',
                description: 'Mostre seus documentos facilmente através de códigos QR seguros.',
                category: 'Compartilhamento',
                status: 'available',
                votes: 123
            }
        ]
    }
];

export const mockTopSuggestions = [
    {
        id: 1,
        title: 'Integração com Google Drive',
        description: 'Sincronização automática com Google Drive para backup duplo dos documentos.',
        author: 'Maria Silva',
        date: new Date('2024-12-10T14:30:00Z'),
        votes: 89,
        userVoted: false
    },
    {
        id: 2,
        title: 'Assinatura Digital Integrada',
        description: 'Poder assinar documentos diretamente na plataforma com validade jurídica.',
        author: 'João Santos',
        date: new Date('2024-12-08T09:15:00Z'),
        votes: 156,
        userVoted: true
    },
    {
        id: 3,
        title: 'Compartilhamento Temporário',
        description: 'Links de compartilhamento que expiram automaticamente após um período.',
        author: 'Ana Costa',
        date: new Date('2024-12-05T16:45:00Z'),
        votes: 67,
        userVoted: false
    },
    {
        id: 4,
        title: 'Modelos de Documentos',
        description: 'Templates prontos para contratos, procurações e outros documentos comuns.',
        author: 'Carlos Oliveira',
        date: new Date('2024-12-03T11:20:00Z'),
        votes: 134,
        userVoted: false
    }
];

export const mockChangelog = [
    {
        id: 1,
        version: '2.4.0',
        title: 'Integração WhatsApp e Melhorias de Performance',
        date: new Date('2024-12-15T10:00:00Z'),
        added: [
            'Integração com WhatsApp Business para notificações',
            'Nova interface de upload com drag & drop',
            'Categorização automática por IA',
            'Sistema de backup criptografado'
        ],
        improved: [
            'Performance geral 40% mais rápida',
            'Interface mobile completamente redesenhada',
            'Sistema de busca mais preciso',
            'Compressão otimizada de imagens'
        ],
        fixed: [
            'Problema de sincronização em dispositivos lentos',
            'Erro ao fazer upload de arquivos muito grandes',
            'Notificações duplicadas em alguns casos',
            'Layout quebrado em telas pequenas'
        ]
    },
    {
        id: 2,
        version: '2.3.1',
        title: 'Correções e Estabilidade',
        date: new Date('2024-11-28T14:30:00Z'),
        added: [
            'Suporte a novos formatos de documento',
            'Exportação em PDF de relatórios'
        ],
        improved: [
            'Velocidade de carregamento de páginas',
            'Precisão do sistema de busca',
            'Responsividade em tablets'
        ],
        fixed: [
            'Falha ao editar documentos em alguns navegadores',
            'Problema de timezone em notificações',
            'Erro de validação em formulários'
        ]
    },
    {
        id: 3,
        version: '2.3.0',
        title: 'Nova Dashboard e Relatórios',
        date: new Date('2024-11-15T09:00:00Z'),
        added: [
            'Dashboard completamente renovada',
            'Sistema de relatórios avançados',
            'Filtros inteligentes por categoria',
            'Widget de documentos vencendo'
        ],
        improved: [
            'Organização de documentos por grupos',
            'Sistema de tags mais flexível',
            'Interface de configurações simplificada'
        ],
        fixed: [
            'Problema de ordenação de documentos',
            'Erro ao compartilhar links em alguns dispositivos',
            'Falha na atualização automática de status'
        ]
    }
];

// ========================================
// SUGESTÕES MOCK
// ========================================
export const mockMySuggestions = [
    {
        id: 1,
        title: 'Integração com Google Drive',
        description: 'Seria incrível poder sincronizar automaticamente meus documentos com o Google Drive para ter um backup duplo. Imagino que funcionaria como uma sincronização bidirecional.',
        justification: 'Uso muito o Google Drive para trabalho e ter tudo sincronizado me daria mais segurança. Às vezes preciso acessar os documentos em outros dispositivos.',
        category: 'integrations',
        priority: 'high',
        email: 'usuario@email.com',
        date: new Date('2024-12-10T14:30:00Z'),
        status: 'reviewing',
        response: 'Ótima sugestão! Estamos analisando a viabilidade técnica desta integração. É uma das funcionalidades mais solicitadas pela comunidade.'
    },
    {
        id: 2,
        title: 'Dark Mode para Interface',
        description: 'Um tema escuro seria muito bom para usar à noite, pois cansaria menos a vista. Poderia ter uma opção de alternar automaticamente baseado no horário.',
        justification: 'Trabalho muito à noite e a tela branca me incomoda. Um dark mode ajudaria muito na minha produtividade.',
        category: 'interface',
        priority: 'medium',
        email: 'usuario@email.com',
        date: new Date('2024-12-05T16:45:00Z'),
        status: 'approved',
        response: 'Funcionalidade aprovada! O dark mode está sendo desenvolvido e deve estar disponível no próximo trimestre.'
    },
    {
        id: 3,
        title: 'Assinatura Digital Integrada',
        description: 'Poder assinar documentos diretamente na plataforma seria revolucionário. Imagino usando certificado digital A1/A3 para validade jurídica.',
        justification: 'Preciso assinar muitos contratos e ter que baixar, assinar em outro lugar e subir novamente é muito trabalhoso.',
        category: 'features',
        priority: 'high',
        email: 'usuario@email.com',
        date: new Date('2024-11-28T09:15:00Z'),
        status: 'implemented',
        response: 'Implementado! A funcionalidade de assinatura digital já está disponível na seção de documentos. Suporte para certificados A1 e A3.'
    },
    {
        id: 4,
        title: 'Notificações Push no Browser',
        description: 'Receber notificações direto no navegador quando um documento estiver vencendo, mesmo com a aba fechada.',
        justification: 'Às vezes esqueço de verificar os emails e acabo perdendo prazos importantes. Notificações push me lembrariam na hora certa.',
        category: 'features',
        priority: 'medium',
        email: 'usuario@email.com',
        date: new Date('2024-11-20T11:20:00Z'),
        status: 'pending',
        response: null
    }
];

export const mockCommunitySuggestions = [
    {
        id: 101,
        title: 'Reconhecimento OCR de Documentos',
        description: 'IA que leia automaticamente as informações dos documentos e preencha os campos como data de vencimento, número do documento, etc.',
        category: 'features',
        author: 'Maria Silva Santos',
        date: new Date('2024-12-12T10:30:00Z'),
        votes: 156,
        userVoted: true
    },
    {
        id: 102,
        title: 'App para Apple Watch',
        description: 'Seria legal ter acesso rápido aos documentos principais direto no relógio, especialmente em situações de emergência.',
        category: 'mobile',
        author: 'João Pedro Costa',
        date: new Date('2024-12-10T14:15:00Z'),
        votes: 89,
        userVoted: false
    },
    {
        id: 103,
        title: 'Compartilhamento Temporário com QR Code',
        description: 'QR codes que expiram após um tempo determinado para compartilhar documentos de forma segura e temporária.',
        category: 'security',
        author: 'Ana Beatriz Lima',
        date: new Date('2024-12-08T16:45:00Z'),
        votes: 203,
        userVoted: false
    },
    {
        id: 104,
        title: 'Integração com Carteira Digital do CPF',
        description: 'Conectar com o CPF digital do governo para validar automaticamente documentos de identidade.',
        category: 'integrations',
        author: 'Carlos Eduardo Souza',
        date: new Date('2024-12-05T09:20:00Z'),
        votes: 234,
        userVoted: true
    },
    {
        id: 105,
        title: 'Backup Automático para Dropbox',
        description: 'Além do Google Drive, seria ótimo ter integração com Dropbox para quem usa essa plataforma.',
        category: 'integrations',
        author: 'Fernanda Oliveira',
        date: new Date('2024-12-03T13:30:00Z'),
        votes: 67,
        userVoted: false
    },
    {
        id: 106,
        title: 'Widget para Desktop',
        description: 'Um widget pequeno para a área de trabalho mostrando documentos próximos do vencimento.',
        category: 'interface',
        author: 'Roberto Martins',
        date: new Date('2024-12-01T11:45:00Z'),
        votes: 123,
        userVoted: false
    },
    {
        id: 107,
        title: 'Modo Offline Completo',
        description: 'Poder acessar e editar informações dos documentos mesmo sem internet, com sincronização posterior.',
        category: 'features',
        author: 'Lucia Fernandes',
        date: new Date('2024-11-28T15:10:00Z'),
        votes: 178,
        userVoted: true
    },
    {
        id: 108,
        title: 'API Pública para Desenvolvedores',
        description: 'Uma API que permita a desenvolvedores criar integrações personalizadas com sistemas próprios.',
        category: 'api',
        author: 'Marcos Silva',
        date: new Date('2024-11-25T10:25:00Z'),
        votes: 145,
        userVoted: false
    }
];

// ========================================
// TIPOS DE ARQUIVO MOCK
// ========================================
export const mockFileTypes = [
    'CNH',
    'RG',
    'CPF',
    'Título de Eleitor',
    'Passaporte',
    'Visto',
    'Carteira de Vacinação',
    'Comprovante de Residência',
    'Contrato',
    'Contrato de Aluguel',
    'CRLV',
    'CNPJ',
    'Alvará',
    'Certidão',
    'Diploma',
    'Certificado',
    'Notas Fiscais de Entrada',
    'Notas Fiscais de Saída',
    'Balancetes Contábeis',
    'Demonstrativos de Resultado',
    'Certificados Digitais',
    'Contratos de Fornecimento'
];

// ========================================
// CLIENTES MOCK
// ========================================
export const mockClients = [
    {
        id: 1,
        name: 'João Silva Santos',
        email: 'joao.silva@email.com',
        type: 'individual'
    },
    {
        id: 2,
        name: 'Restaurante Sabor Caseiro Ltda',
        email: 'contato@saborcaseiro.com.br',
        type: 'company'
    },
    {
        id: 3,
        name: 'TechCorp Soluções Digitais',
        email: 'admin@techcorp.com.br',
        type: 'company'
    },
    {
        id: 4,
        name: 'Maria Santos Oliveira',
        email: 'maria.santos@email.com',
        type: 'individual'
    },
    {
        id: 5,
        name: 'Consultoria Empresarial JR',
        email: 'contato@consultoriajr.com.br',
        type: 'company'
    }
];

// ========================================
// AUTOMAÇÕES DE EMAIL MOCK
// ========================================
export const mockAutomationEmails = [
    {
        id: 1,
        name: 'Envio de Documentos de Auditoria',
        description: 'Envio único de documentos para auditoria externa agendada',
        active: true,
        frequency: 'once',
        time: new Date('2025-09-25T14:30:00'),
        fileSelectionType: 'category',
        fileSelectionValue: ['financeiro', 'trabalho'],
        fileSelection: {
            type: 'category',
            values: ['financeiro', 'trabalho'],
            label: '2 categoria(s)'
        },
        recipients: [
            'auditoria@externafirma.com.br',
            'compliance@empresa.com.br'
        ],
        emailSubject: 'Documentos para Auditoria - Setembro 2025',
        emailMessage: 'Seguem em anexo os documentos solicitados para a auditoria externa.',
        lastRun: null,
        nextRun: '2025-09-25T14:30:00',
        status: 'active',
        createdAt: '2025-09-20T10:00:00',
        updatedAt: '2025-09-20T10:00:00'
    },
    {
        id: 2,
        name: 'Envio Mensal de Balancetes',
        description: 'Envio automático de balancetes contábeis todo dia 5 do mês',
        active: true,
        frequency: 'monthly',
        time: new Date('2025-09-20T09:00:00'),
        monthlyType: 'day',
        monthDay: 5,
        fileSelectionType: 'type',
        fileSelectionValue: ['Balancetes Contábeis', 'Demonstrativos de Resultado'],
        fileSelection: {
            type: 'type',
            values: ['Balancetes Contábeis', 'Demonstrativos de Resultado'],
            label: '2 tipo(s) de documento'
        },
        recipients: [
            'contador@empresa.com.br',
            'diretor@empresa.com.br',
            'administrativo@empresa.com.br'
        ],
        emailSubject: 'Balancetes Contábeis - Envio Automático',
        emailMessage: 'Segue em anexo os balancetes contábeis do período.\n\nAtenciosamente,\nEquipe FileSave',
        lastExecution: '2024-12-05T09:00:00Z',
        monthlyCount: 15,
        totalSent: 45,
        successfulSent: 44,
        createdAt: '2024-10-15T14:30:00Z',
        updatedAt: '2024-12-01T10:15:00Z'
    },
    {
        id: 2,
        name: 'Relatório Semanal de Documentos',
        description: 'Envio de relatório com status dos documentos toda sexta-feira',
        active: true,
        frequency: 'weekly',
        time: '17:00',
        weekdays: ['friday'],
        fileSelectionType: 'category',
        fileSelectionValue: ['trabalho', 'financeiro'],
        fileSelection: {
            type: 'category',
            values: ['trabalho', 'financeiro'],
            label: '2 categoria(s)'
        },
        recipients: [
            'gerencia@empresa.com.br',
            'rh@empresa.com.br'
        ],
        emailSubject: 'Relatório Semanal - Status dos Documentos',
        emailMessage: 'Relatório semanal com o status atualizado de todos os documentos.\n\nBom final de semana!',
        lastExecution: '2024-12-13T17:00:00Z',
        monthlyCount: 8,
        totalSent: 32,
        successfulSent: 32,
        createdAt: '2024-11-01T16:20:00Z',
        updatedAt: '2024-12-10T11:45:00Z'
    },
    {
        id: 3,
        name: 'Backup de Certificados Digitais',
        description: 'Backup diário dos certificados digitais para segurança',
        active: false,
        frequency: 'daily',
        time: '02:00',
        fileSelectionType: 'type',
        fileSelectionValue: ['Certificados Digitais'],
        fileSelection: {
            type: 'type',
            values: ['Certificados Digitais'],
            label: '1 tipo(s) de documento'
        },
        recipients: [
            'ti@empresa.com.br',
            'backup@empresa.com.br'
        ],
        emailSubject: 'Backup Diário - Certificados Digitais',
        emailMessage: 'Backup automático dos certificados digitais para segurança.\n\nEste é um processo automatizado.',
        lastExecution: '2024-12-10T02:00:00Z',
        monthlyCount: 0,
        totalSent: 180,
        successfulSent: 175,
        createdAt: '2024-09-20T09:10:00Z',
        updatedAt: '2024-12-10T14:22:00Z'
    },
    {
        id: 4,
        name: 'Notas Fiscais para Contabilidade',
        description: 'Envio semanal das notas fiscais para o escritório de contabilidade',
        active: true,
        frequency: 'weekly',
        weekdays: ['monday', 'friday'],
        time: new Date('2025-09-20T10:30:00'),
        fileSelectionType: 'type',
        fileSelectionValue: ['Notas Fiscais de Entrada', 'Notas Fiscais de Saída'],
        fileSelection: {
            type: 'type',
            values: ['Notas Fiscais de Entrada', 'Notas Fiscais de Saída'],
            label: '2 tipo(s) de documento'
        },
        recipients: [
            'contabilidade@escritorio.com.br',
            'fiscal@escritorio.com.br'
        ],
        emailSubject: 'Notas Fiscais Quinzenais - Período [DATA]',
        emailMessage: 'Seguem em anexo as notas fiscais do período quinzenal.\n\nFicamos à disposição para esclarecimentos.',
        lastExecution: '2024-12-01T10:30:00Z',
        monthlyCount: 4,
        totalSent: 24,
        successfulSent: 24,
        createdAt: '2024-08-15T13:45:00Z',
        updatedAt: '2024-11-28T16:30:00Z'
    },
    {
        id: 5,
        name: 'Documentos Pessoais - Cliente João',
        description: 'Envio mensal dos documentos pessoais atualizados para o cliente',
        active: true,
        frequency: 'monthly',
        time: '14:00',
        monthlyType: 'last',
        fileSelectionType: 'client',
        fileSelectionValue: [1],
        fileSelection: {
            type: 'client',
            values: [1],
            label: '1 cliente(s)'
        },
        recipients: [
            'joao.silva@email.com'
        ],
        emailSubject: 'Seus Documentos Mensais - FileSave',
        emailMessage: 'Olá João!\n\nSegue a atualização mensal dos seus documentos.\n\nAtt,\nEquipe FileSave',
        lastExecution: '2024-11-30T14:00:00Z',
        monthlyCount: 2,
        totalSent: 6,
        successfulSent: 6,
        createdAt: '2024-09-30T12:15:00Z',
        updatedAt: '2024-11-25T10:40:00Z'
    },
    {
        id: 4,
        name: 'Upload de Documentos Mensais - Contador',
        description: 'Criada página de upload para receber documentos do contador. Aguardando uploads.',
        active: true,
        waiting: true, // Status especial para automações aguardando arquivos
        frequency: 'monthly',
        time: '10:00',
        monthlyType: 'day',
        monthDay: 1,
        fileSelectionType: 'uploadPage',
        fileSelectionValue: ['upload-page-contador-123'],
        fileSelection: {
            type: 'uploadPage',
            values: ['upload-page-contador-123'],
            label: 'Página: Upload Contador Mensal'
        },
        recipients: [
            'contabilidade@empresa.com.br',
            'financeiro@empresa.com.br'
        ],
        emailSubject: 'Documentos Mensais do Contador - {month}/{year}',
        emailMessage: 'Prezados,\n\nSegue em anexo os documentos enviados pelo contador referente ao período {month}/{year}.\n\nDocumentos anexados automaticamente via página de upload.\n\nAtenciosamente,\nFileSave',
        uploadPageUrl: 'https://filesave.com/upload/contador-mensal-xyz123',
        pendingUploads: true,
        expectedFiles: ['Balancetes', 'DRE', 'Conciliações Bancárias', 'Notas Fiscais'],
        uploadDeadline: '2024-12-25T23:59:59Z',
        lastExecution: null, // Nunca executou pois aguarda arquivos
        monthlyCount: 0,
        totalSent: 0,
        successfulSent: 0,
        createdAt: '2024-12-01T10:30:00Z',
        updatedAt: '2024-12-15T14:20:00Z'
    },
    {
        id: 5,
        name: 'Relatório Trimestral - Aguardando NFEs',
        description: 'Automação aguardando upload das notas fiscais de dezembro para completar o relatório trimestral.',
        active: true,
        waiting: true,
        frequency: 'monthly',
        monthlyType: 'day',
        monthDay: 1,
        time: new Date('2025-09-20T15:00:00'),
        fileSelectionType: 'uploadPage',
        fileSelectionValue: ['upload-page-nfe-trimestral'],
        fileSelection: {
            type: 'uploadPage',
            values: ['upload-page-nfe-trimestral'],
            label: 'Página: NFEs Trimestre'
        },
        recipients: [
            'diretoria@empresa.com.br',
            'auditoria@empresa.com.br'
        ],
        emailSubject: 'Relatório Trimestral Consolidado - Q{quarter}/{year}',
        emailMessage: 'Prezados,\n\nSegue em anexo o relatório trimestral consolidado com todas as notas fiscais do período Q{quarter}/{year}.\n\nRelatório gerado automaticamente após recebimento dos documentos.\n\nAtenciosamente,\nFileSave',
        uploadPageUrl: 'https://filesave.com/upload/nfe-trimestral-abc456',
        pendingUploads: true,
        expectedFiles: ['NFe Dezembro', 'NFe de Serviços', 'Cancelamentos', 'Cartas de Correção'],
        uploadDeadline: '2024-12-31T23:59:59Z',
        lastExecution: '2024-10-01T15:00:00Z', // Último trimestre executado
        monthlyCount: 0, // Não se aplica para trimestral
        totalSent: 3, // 3 trimestres já enviados
        successfulSent: 3,
        createdAt: '2024-01-15T11:00:00Z',
        updatedAt: '2024-12-15T16:30:00Z'
    },
    {
        id: 6,
        name: 'Documentos Contábeis - Academia Fitness Pro',
        title: 'Documentos Contábeis - Academia Fitness Pro',
        description: 'Aguardando upload de notas fiscais de setembro para envio automático ao contador',
        status: 'waiting',
        active: true,
        waiting: true,
        frequency: 'monthly',
        monthlyType: 'day',
        monthDay: 5,
        time: new Date('2024-09-30T14:00:00'),
        fileSelectionType: 'uploadPage',
        fileSelectionValue: ['upload-page-academia-fitness'],
        fileSelection: {
            type: 'uploadPage',
            values: ['upload-page-academia-fitness'],
            label: 'Página: Documentos Academia Fitness'
        },
        recipients: [
            'maria@contabilidade.com',
            'financeiro@academiafitness.com'
        ],
        emailSubject: 'Documentos Contábeis Mensais - Academia Fitness Pro - {month}/{year}',
        emailMessage: 'Prezada Maria,\n\nSegue em anexo os documentos contábeis da Academia Fitness Pro referente ao período {month}/{year}.\n\nDocumentos enviados automaticamente após upload.\n\nAtenciosamente,\nFileSave',
        uploadPageUrl: 'https://filesave.com/upload/academia-fitness-contabil-abc789',
        pendingUploads: true,
        expectedFiles: ['Notas Fiscais Set/24', 'Extratos Bancários Set/24', 'Folha de Pagamento'],
        uploadDeadline: '2024-09-30T23:59:59Z',
        lastExecution: null,
        monthlyCount: 0,
        totalSent: 0,
        successfulSent: 0,
        createdAt: '2024-09-01T10:00:00Z',
        updatedAt: '2024-09-20T15:30:00Z'
    },
    {
        id: 7,
        name: 'Relatórios Mensais - Startup TechFlow',
        title: 'Relatórios Mensais - Startup TechFlow',
        description: 'Aguardando relatórios financeiros para envio aos investidores',
        status: 'waiting',
        active: true,
        waiting: true,
        frequency: 'monthly',
        monthlyType: 'day',
        monthDay: 1,
        time: new Date('2024-09-25T09:00:00'),
        fileSelectionType: 'uploadPage',
        fileSelectionValue: ['upload-page-techflow-investors'],
        fileSelection: {
            type: 'uploadPage',
            values: ['upload-page-techflow-investors'],
            label: 'Página: Relatórios TechFlow'
        },
        recipients: [
            'joao@venture.com',
            'ana@capital.com',
            'diretoria@techflow.com'
        ],
        emailSubject: 'Relatórios Financeiros Mensais - TechFlow - {month}/{year}',
        emailMessage: 'Prezados Investidores,\n\nSegue em anexo os relatórios financeiros da TechFlow referente ao período {month}/{year}.\n\nRelatórios consolidados automaticamente após recebimento dos documentos.\n\nAtenciosamente,\nEquipe TechFlow via FileSave',
        uploadPageUrl: 'https://filesave.com/upload/techflow-relatorios-def456',
        pendingUploads: true,
        expectedFiles: ['Relatório Financeiro Set/24', 'DRE Setembro', 'Fluxo de Caixa'],
        uploadDeadline: '2024-09-25T18:00:00Z',
        lastExecution: null,
        monthlyCount: 0,
        totalSent: 0,
        successfulSent: 0,
        createdAt: '2024-08-15T14:00:00Z',
        updatedAt: '2024-09-22T11:45:00Z'
    }
];

// ========================================
// EMPRESAS MOCK - ORGANIZAÇÕES
// ========================================
export const mockCompanies = [
    {
        id: 1,
        name: 'Restaurante Sabor Caseiro Ltda',
        shortName: 'Sabor Caseiro',
        image: 'https://www.fivebranches.edu/wp-content/uploads/2021/08/default-image.jpg',
        count: 28,
        type: 'Restaurante',
        lastActivity: '2024-12-01T10:30:00Z',
        status: 'active',
        stats: {
            expiring: 3,
            expired: 1,
            active: 24
        }
    },
    {
        id: 2,
        name: 'Loja Mania Fashion ME',
        shortName: 'Mania Fashion',
        count: 22,
        type: 'Varejo',
        lastActivity: '2024-11-28T14:15:00Z',
        status: 'active',
        stats: {
            expiring: 2,
            expired: 0,
            active: 20
        }
    },
    {
        id: 3,
        name: 'Distribuidora Central S.A.',
        shortName: 'Distribuidora Central',
        image: 'https://www.fivebranches.edu/wp-content/uploads/2021/08/default-image.jpg',
        count: 35,
        type: 'Distribuidora',
        lastActivity: '2024-11-25T09:45:00Z',
        status: 'active',
        stats: {
            expiring: 4,
            expired: 2,
            active: 29
        }
    },
    {
        id: 4,
        name: 'Consultoria Empresarial Silva & Associados',
        shortName: 'Silva & Associados',
        count: 15,
        type: 'Consultoria',
        lastActivity: '2024-11-20T16:20:00Z',
        status: 'active',
        stats: {
            expiring: 1,
            expired: 0,
            active: 14
        }
    },
    {
        id: 5,
        name: 'Academia Fitness Pro',
        shortName: 'Fitness Pro',
        image: 'https://www.fivebranches.edu/wp-content/uploads/2021/08/default-image.jpg',
        count: 18,
        type: 'Academia',
        lastActivity: '2024-11-18T11:10:00Z',
        status: 'active',
        stats: {
            expiring: 2,
            expired: 1,
            active: 15
        }
    },
    {
        id: 6,
        name: 'Startup TechFlow Innovations',
        shortName: 'TechFlow',
        count: 12,
        type: 'Tecnologia',
        lastActivity: '2024-11-15T13:25:00Z',
        status: 'active',
        stats: {
            expiring: 1,
            expired: 0,
            active: 11
        }
    },
    {
        id: 7,
        name: 'Indústria Metalúrgica Costa',
        shortName: 'Metalúrgica Costa',
        image: 'https://www.fivebranches.edu/wp-content/uploads/2021/08/default-image.jpg',
        count: 42,
        type: 'Indústria',
        lastActivity: '2024-11-10T08:30:00Z',
        status: 'active',
        stats: {
            expiring: 5,
            expired: 3,
            active: 34
        }
    },
    {
        id: 8,
        name: 'Farmácia Popular Saúde',
        shortName: 'Popular Saúde',
        count: 19,
        type: 'Farmácia',
        lastActivity: '2024-11-08T15:45:00Z',
        status: 'active',
        stats: {
            expiring: 2,
            expired: 1,
            active: 16
        }
    }
];

// ========================================
// MOCK DATA - ALERTAS INTELIGENTES
// ========================================
export const mockAutomationAlerts = [
    {
        id: 1,
        name: 'CNH - João Silva Santos',
        documentId: 1,
        documentType: 'CNH',
        documentName: 'CNH - João Silva Santos',
        personType: 'NATURAL',
        expiryDate: '2027-03-15T23:59:59Z',
        triggerDays: [30, 15, 7, 3, 1],
        recipients: ['joao.silva@email.com', 'admin@empresa.com'],
        notificationChannels: ['email'],
        customMessage: 'Sua CNH está próxima do vencimento. Renove com antecedência para evitar transtornos.',
        preferredTime: '09:00',
        status: 'active',
        urgencyLevel: 'safe',
        lastNotification: null,
        nextNotification: '2027-02-13T09:00:00Z',
        createdAt: '2024-12-15T10:00:00Z',
        updatedAt: '2024-12-15T10:00:00Z'
    },
    {
        id: 2,
        name: 'Passaporte - Ana Costa Silva',
        documentId: 11,
        documentType: 'Passaporte',
        documentName: 'Passaporte - Ana Costa Silva',
        personType: 'NATURAL',
        expiryDate: '2029-10-20T23:59:59Z',
        triggerDays: [60, 30, 15],
        recipients: ['ana.costa@email.com'],
        notificationChannels: ['email'],
        customMessage: 'Seu passaporte vencerá em breve. Inicie o processo de renovação.',
        preferredTime: '14:00',
        status: 'active',
        urgencyLevel: 'safe',
        lastNotification: null,
        nextNotification: '2029-08-21T14:00:00Z',
        createdAt: '2024-12-10T15:30:00Z',
        updatedAt: '2024-12-10T15:30:00Z'
    },
    {
        id: 3,
        name: 'Contrato Aluguel - Apartamento Centro',
        documentId: 7,
        documentType: 'Contrato de Aluguel',
        documentName: 'Contrato de Aluguel - Apartamento Centro',
        personType: 'NATURAL',
        category: 'imoveis',
        expiryDate: '2024-11-15T23:59:59Z',
        triggerDays: [30, 15, 7, 1],
        recipients: ['maria.santos@email.com', 'imobiliaria@contato.com'],
        notificationChannels: ['email'],
        customMessage: 'O contrato de aluguel está vencendo. Entre em contato para renovação.',
        preferredTime: '10:00',
        status: 'urgent',
        urgencyLevel: 'critical',
        lastNotification: '2024-11-30T10:00:00Z',
        nextNotification: null,
        createdAt: '2024-10-15T09:00:00Z',
        updatedAt: '2024-11-30T10:00:00Z'
    },
    {
        id: 4,
        name: 'Comprovante Residência - Maria Santos',
        documentId: 2,
        documentType: 'Comprovante de Residência',
        documentName: 'Comprovante de Residência - Maria Santos',
        personType: 'NATURAL',
        category: 'pessoal',
        expiryDate: '2025-09-15T23:59:59Z',
        triggerDays: [60, 30, 15, 7],
        recipients: ['maria.santos@email.com'],
        notificationChannels: ['email'],
        customMessage: 'Seu comprovante de residência expirará em breve. Providencie um novo documento.',
        preferredTime: '16:00',
        status: 'active',
        urgencyLevel: 'warning',
        lastNotification: null,
        nextNotification: '2025-07-16T16:00:00Z',
        createdAt: '2024-11-20T16:45:00Z',
        updatedAt: '2024-11-20T16:45:00Z'
    },
    {
        id: 5,
        name: 'RG - João Silva Santos',
        documentId: 12,
        documentType: 'RG',
        documentName: 'RG - João Silva Santos',
        personType: 'NATURAL',
        expiryDate: '2034-10-25T23:59:59Z',
        triggerDays: [365, 180, 90, 30],
        recipients: ['joao.silva@email.com'],
        notificationChannels: ['email'],
        customMessage: 'Seu RG está se aproximando do vencimento.',
        preferredTime: '08:00',
        status: 'active',
        urgencyLevel: 'safe',
        lastNotification: null,
        nextNotification: '2033-10-25T08:00:00Z',
        createdAt: '2024-12-10T15:45:00Z',
        updatedAt: '2024-12-10T15:45:00Z'
    },
    {
        id: 6,
        name: 'CRLV - Veículo Fiat Toro',
        documentId: 13,
        documentType: 'CRLV',
        documentName: 'CRLV - Veículo Fiat Toro',
        personType: 'NATURAL',
        category: 'veiculos',
        expiryDate: '2026-09-25T23:59:59Z',
        triggerDays: [90, 60, 30, 15, 7],
        recipients: ['joao.silva@email.com', 'despachante@servicos.com'],
        notificationChannels: ['email'],
        customMessage: 'O CRLV do seu veículo está próximo do vencimento. Providencie a renovação.',
        preferredTime: '11:00',
        status: 'active',
        urgencyLevel: 'warning',
        lastNotification: null,
        nextNotification: '2026-06-27T11:00:00Z',
        createdAt: '2024-12-10T16:00:00Z',
        updatedAt: '2024-12-10T16:00:00Z'
    },
    {
        id: 7,
        name: 'Alvará Funcionamento - Loja Comercial',
        documentId: 8,
        documentType: 'Alvará',
        documentName: 'Alvará de Funcionamento - Loja Comercial',
        personType: 'COMPANY',
        clientId: 2,
        category: 'empresa',
        expiryDate: '2024-10-15T23:59:59Z',
        triggerDays: [60, 30, 15],
        recipients: ['comercial@loja.com', 'juridico@loja.com'],
        notificationChannels: ['email'],
        customMessage: 'O alvará de funcionamento precisa ser renovado em breve.',
        preferredTime: '13:00',
        status: 'inactive',
        urgencyLevel: 'warning',
        lastNotification: null,
        nextNotification: null,
        createdAt: '2024-11-28T15:30:00Z',
        updatedAt: '2024-12-15T11:00:00Z'
    },
    {
        id: 8,
        name: 'Diploma Graduação - Ana Costa',
        documentId: 9,
        documentType: 'Diploma',
        documentName: 'Diploma de Graduação - Ana Costa',
        personType: 'NATURAL',
        category: 'educacao',
        expiryDate: null,
        triggerDays: [],
        recipients: ['ana.costa@email.com'],
        notificationChannels: ['email'],
        customMessage: 'Documento sem vencimento - apenas para referência.',
        preferredTime: '12:00',
        status: 'inactive',
        urgencyLevel: 'safe',
        lastNotification: null,
        nextNotification: null,
        createdAt: '2024-12-05T14:00:00Z',
        updatedAt: '2024-12-15T09:30:00Z'
    },
    {
        id: 9,
        name: 'Licença Ambiental - TechCorp Soluções',
        documentId: 14,
        documentType: 'Licença Ambiental',
        documentName: 'Licença Ambiental - TechCorp Soluções Digitais',
        personType: 'COMPANY',
        clientId: 3,
        category: 'juridico',
        expiryDate: '2025-06-30T23:59:59Z',
        triggerDays: [90, 60, 30, 15],
        recipients: ['admin@techcorp.com.br', 'juridico@techcorp.com.br'],
        notificationChannels: ['email'],
        customMessage: 'A licença ambiental da empresa vencerá em breve. Providencie a renovação.',
        preferredTime: '15:00',
        status: 'active',
        urgencyLevel: 'warning',
        lastNotification: null,
        nextNotification: '2025-04-01T15:00:00Z',
        createdAt: '2024-12-01T10:00:00Z',
        updatedAt: '2024-12-01T10:00:00Z'
    },
    {
        id: 8,
        name: 'RG - Maria Oliveira',
        documentId: 12,
        documentType: 'RG',
        documentName: 'RG - Maria Oliveira',
        personType: 'NATURAL',
        expiryDate: '2024-11-28T23:59:59Z', // Já vencido
        triggerDays: [30, 15, 7, 3, 1],
        recipients: ['maria.oliveira@email.com'],
        notificationChannels: ['email'],
        customMessage: 'Seu RG venceu. Agende a renovação urgentemente.',
        preferredTime: '08:00',
        status: 'urgent',
        urgencyLevel: 'critical',
        lastNotification: '2024-11-27T08:00:00Z',
        nextNotification: null,
        createdAt: '2024-10-01T10:00:00Z',
        updatedAt: '2024-11-27T08:00:00Z'
    },
    {
        id: 9,
        name: 'IPVA 2024 - Veículo ABC-1234',
        documentId: 13,
        documentType: 'IPVA',
        documentName: 'IPVA 2024',
        personType: 'NATURAL',
        expiryDate: '2024-12-31T23:59:59Z', // Vence em poucos dias
        triggerDays: [30, 15, 7, 3, 1],
        recipients: ['proprietario@email.com'],
        notificationChannels: ['email'],
        customMessage: 'O IPVA do seu veículo está próximo do vencimento.',
        preferredTime: '10:00',
        status: 'active',
        urgencyLevel: 'critical',
        lastNotification: '2024-12-24T10:00:00Z',
        nextNotification: '2024-12-28T10:00:00Z',
        createdAt: '2024-11-15T10:00:00Z',
        updatedAt: '2024-12-24T10:00:00Z'
    },
    {
        id: 10,
        name: 'Seguro Residencial',
        documentId: 14,
        documentType: 'Seguro',
        documentName: 'Seguro Residencial - Apólice 123456',
        personType: 'NATURAL',
        expiryDate: '2025-01-15T23:59:59Z', // Vence em 18 dias
        triggerDays: [30, 15, 7],
        recipients: ['segurado@email.com', 'corretor@seguradora.com'],
        notificationChannels: ['email'],
        customMessage: 'Seu seguro residencial está próximo do vencimento. Renove para manter a proteção.',
        preferredTime: '09:00',
        status: 'active',
        urgencyLevel: 'warning',
        lastNotification: null,
        nextNotification: '2025-01-01T09:00:00Z',
        createdAt: '2024-12-01T10:00:00Z',
        updatedAt: '2024-12-01T10:00:00Z'
    },
    {
        id: 11,
        name: 'Certificado Digital e-CPF',
        documentId: 15,
        documentType: 'Certificado Digital',
        documentName: 'e-CPF A3',
        personType: 'NATURAL',
        expiryDate: '2024-10-15T23:59:59Z', // Vencido há 2 meses
        triggerDays: [30, 15, 7, 3, 1],
        recipients: ['usuario@email.com'],
        notificationChannels: ['email'],
        customMessage: 'Seu certificado digital venceu. Renove para continuar assinando documentos.',
        preferredTime: '08:30',
        status: 'urgent',
        urgencyLevel: 'critical',
        lastNotification: '2024-10-14T08:30:00Z',
        nextNotification: null,
        createdAt: '2024-08-01T10:00:00Z',
        updatedAt: '2024-10-14T08:30:00Z'
    },
    {
        id: 12,
        name: 'Carteira de Vacinação - COVID-19',
        documentId: 16,
        documentType: 'Carteira de Vacinação',
        documentName: 'Certificado de Vacinação COVID-19',
        personType: 'NATURAL',
        expiryDate: '2025-01-10T23:59:59Z', // Vence em 13 dias
        triggerDays: [30, 15, 7],
        recipients: ['paciente@email.com'],
        notificationChannels: ['email'],
        customMessage: 'Seu certificado de vacinação está próximo do vencimento. Verifique a necessidade de dose de reforço.',
        preferredTime: '11:00',
        status: 'active',
        urgencyLevel: 'warning',
        lastNotification: null,
        nextNotification: '2024-12-27T11:00:00Z',
        createdAt: '2024-11-20T10:00:00Z',
        updatedAt: '2024-11-20T10:00:00Z'
    }
];

